// 自動生成されたマスターデータクライアント
// このファイルは自動生成されます。手動で編集しないでください。

import React from "react";
import type {
  MstAchievement,
  MstAchievementID,
  MstAssetVersion,
  MstAssetVersionID,
  MstCharacter,
  MstCharacterBond,
  MstCharacterBondID,
  MstCharacterID,
  MstCharacterProfile,
  MstCharacterProfileID,
  MstCharacterSkin,
  MstCharacterSkinID,
  MstCurrency,
  MstCurrencyID,
  MstErrorCode,
  MstErrorCodeID,
  MstHomeBackground,
  MstHomeBackgroundID,
  MstIcon,
  MstIconFrame,
  MstIconFrameID,
  MstIconID,
  MstMission,
  MstMissionID,
  MstPaidShop,
  MstPaidShopBundleSet,
  MstPaidShopBundleSetID,
  MstPaidShopID,
  MstSeason,
  MstSeasonID,
  MstShogiBoard,
  MstShogiBoardID,
  MstShogiIngameBGM,
  MstShogiIngameBGMID,
  MstShogiPiece,
  MstShogiPieceEffect,
  MstShogiPieceEffectID,
  MstShogiPieceID,
  MstShogiPieceSound,
  MstShogiPieceSoundID,
  MstSubscriptionPlan,
  MstSubscriptionPlanID,
} from "./MasterTypes";

// JSONファイルのインポート

import MstAchievementData from "../../../../static/json/masterdata/default/mst_achievement.json";

import MstAssetVersionData from "../../../../static/json/masterdata/default/mst_asset_version.json";

import MstCharacterData from "../../../../static/json/masterdata/default/mst_character.json";

import MstCharacterBondData from "../../../../static/json/masterdata/default/mst_character_bond.json";

import MstCharacterProfileData from "../../../../static/json/masterdata/default/mst_character_profile.json";

import MstCharacterSkinData from "../../../../static/json/masterdata/default/mst_character_skin.json";

import MstCurrencyData from "../../../../static/json/masterdata/default/mst_currency.json";

import MstErrorCodeData from "../../../../static/json/masterdata/default/mst_error_code.json";

import MstHomeBackgroundData from "../../../../static/json/masterdata/default/mst_home_background.json";

import MstIconData from "../../../../static/json/masterdata/default/mst_icon.json";

import MstIconFrameData from "../../../../static/json/masterdata/default/mst_icon_frame.json";

import MstMissionData from "../../../../static/json/masterdata/default/mst_mission.json";

import MstPaidShopData from "../../../../static/json/masterdata/default/mst_paid_shop.json";

import MstPaidShopBundleSetData from "../../../../static/json/masterdata/default/mst_paid_shop_bundle_set.json";

import MstSeasonData from "../../../../static/json/masterdata/default/mst_season.json";

import MstShogiBoardData from "../../../../static/json/masterdata/default/mst_shogi_board.json";

import MstShogiIngameBGMData from "../../../../static/json/masterdata/default/mst_shogi_ingame_bgm.json";

import MstShogiPieceData from "../../../../static/json/masterdata/default/mst_shogi_piece.json";

import MstShogiPieceEffectData from "../../../../static/json/masterdata/default/mst_shogi_piece_effect.json";

import MstShogiPieceSoundData from "../../../../static/json/masterdata/default/mst_shogi_piece_sound.json";

import MstSubscriptionPlanData from "../../../../static/json/masterdata/default/mst_subscription_plan.json";

// ウィジェットのインポート

import { MstAchievementSelector } from "./widgets/MstAchievementSelector";

import { MstAssetVersionSelector } from "./widgets/MstAssetVersionSelector";

import { MstCharacterSelector } from "./widgets/MstCharacterSelector";

import { MstCharacterBondSelector } from "./widgets/MstCharacterBondSelector";

import { MstCharacterProfileSelector } from "./widgets/MstCharacterProfileSelector";

import { MstCharacterSkinSelector } from "./widgets/MstCharacterSkinSelector";

import { MstCurrencySelector } from "./widgets/MstCurrencySelector";

import { MstErrorCodeSelector } from "./widgets/MstErrorCodeSelector";

import { MstHomeBackgroundSelector } from "./widgets/MstHomeBackgroundSelector";

import { MstIconSelector } from "./widgets/MstIconSelector";

import { MstIconFrameSelector } from "./widgets/MstIconFrameSelector";

import { MstMissionSelector } from "./widgets/MstMissionSelector";

import { MstPaidShopSelector } from "./widgets/MstPaidShopSelector";

import { MstPaidShopBundleSetSelector } from "./widgets/MstPaidShopBundleSetSelector";

import { MstSeasonSelector } from "./widgets/MstSeasonSelector";

import { MstShogiBoardSelector } from "./widgets/MstShogiBoardSelector";

import { MstShogiIngameBGMSelector } from "./widgets/MstShogiIngameBGMSelector";

import { MstShogiPieceSelector } from "./widgets/MstShogiPieceSelector";

import { MstShogiPieceEffectSelector } from "./widgets/MstShogiPieceEffectSelector";

import { MstShogiPieceSoundSelector } from "./widgets/MstShogiPieceSoundSelector";

import { MstSubscriptionPlanSelector } from "./widgets/MstSubscriptionPlanSelector";

// マスターデータクライアント
export class MasterDataClient {
  // MstAchievement 関連メソッド
  private static _MstAchievementCache: Map<
    MstAchievementID,
    MstAchievement
  > | null = null;
  private static _MstAchievementAll: MstAchievement[] | null = null;

  /**
   * MstAchievementを全て取得
   * @returns MstAchievement[]
   */
  static getMstAchievementAll(): MstAchievement[] {
    if (this._MstAchievementAll === null) {
      this.loadMstAchievementData();
    }
    return this._MstAchievementAll!;
  }

  /**
   * MstAchievementをIDで取得
   * @param id MstAchievementID
   * @returns MstAchievement | undefined
   */
  static getMstAchievement(id: MstAchievementID): MstAchievement | undefined {
    if (this._MstAchievementCache === null) {
      this.loadMstAchievementData();
    }
    return this._MstAchievementCache!.get(id);
  }

  /**
   * MstAchievementをIDで取得（必須）
   * @param id MstAchievementID
   * @returns MstAchievement
   * @throws Error IDが見つからない場合
   */
  static mustGetMstAchievement(id: MstAchievementID): MstAchievement {
    const item = this.getMstAchievement(id);
    if (item === undefined) {
      throw new Error(`MstAchievement with ID ${id} not found`);
    }
    return item;
  }

  /**
   * MstAchievementデータをロード
   */
  private static loadMstAchievementData(): void {
    const items = MstAchievementData as MstAchievement[];

    // メソッドを追加
    const enhancedItems = items.map((item) => ({
      ...item,
      isAvailable: function (now?: Date): boolean {
        const currentTime = now || new Date();
        const beginTime = new Date(this.begin_date);
        const endTime = new Date(this.end_date);
        return currentTime > beginTime && currentTime < endTime;
      },
      isReleased: function (now?: Date): boolean {
        const currentTime = now || new Date();
        const beginTime = new Date(this.begin_date);
        return currentTime > beginTime;
      },
    }));

    this._MstAchievementAll = enhancedItems;
    this._MstAchievementCache = new Map();

    for (const item of enhancedItems) {
      this._MstAchievementCache.set(item.id as MstAchievementID, item);
    }
  }

  /**
   * MstAchievementデータをリロード
   */
  static reloadMstAchievementData(): void {
    this._MstAchievementCache = null;
    this._MstAchievementAll = null;
    this.loadMstAchievementData();
  }

  // MstAssetVersion 関連メソッド
  private static _MstAssetVersionCache: Map<
    MstAssetVersionID,
    MstAssetVersion
  > | null = null;
  private static _MstAssetVersionAll: MstAssetVersion[] | null = null;

  /**
   * MstAssetVersionを全て取得
   * @returns MstAssetVersion[]
   */
  static getMstAssetVersionAll(): MstAssetVersion[] {
    if (this._MstAssetVersionAll === null) {
      this.loadMstAssetVersionData();
    }
    return this._MstAssetVersionAll!;
  }

  /**
   * MstAssetVersionをIDで取得
   * @param id MstAssetVersionID
   * @returns MstAssetVersion | undefined
   */
  static getMstAssetVersion(
    id: MstAssetVersionID
  ): MstAssetVersion | undefined {
    if (this._MstAssetVersionCache === null) {
      this.loadMstAssetVersionData();
    }
    return this._MstAssetVersionCache!.get(id);
  }

  /**
   * MstAssetVersionをIDで取得（必須）
   * @param id MstAssetVersionID
   * @returns MstAssetVersion
   * @throws Error IDが見つからない場合
   */
  static mustGetMstAssetVersion(id: MstAssetVersionID): MstAssetVersion {
    const item = this.getMstAssetVersion(id);
    if (item === undefined) {
      throw new Error(`MstAssetVersion with ID ${id} not found`);
    }
    return item;
  }

  /**
   * MstAssetVersionデータをロード
   */
  private static loadMstAssetVersionData(): void {
    const items = MstAssetVersionData as MstAssetVersion[];

    // メソッドを追加
    const enhancedItems = items.map((item) => ({
      ...item,
      isAvailable: function (now?: Date): boolean {
        const currentTime = now || new Date();
        const beginTime = new Date(this.begin_date);
        const endTime = new Date(this.end_date);
        return currentTime > beginTime && currentTime < endTime;
      },
      isReleased: function (now?: Date): boolean {
        const currentTime = now || new Date();
        const beginTime = new Date(this.begin_date);
        return currentTime > beginTime;
      },
    }));

    this._MstAssetVersionAll = enhancedItems;
    this._MstAssetVersionCache = new Map();

    for (const item of enhancedItems) {
      this._MstAssetVersionCache.set(item.id as MstAssetVersionID, item);
    }
  }

  /**
   * MstAssetVersionデータをリロード
   */
  static reloadMstAssetVersionData(): void {
    this._MstAssetVersionCache = null;
    this._MstAssetVersionAll = null;
    this.loadMstAssetVersionData();
  }

  // MstCharacter 関連メソッド
  private static _MstCharacterCache: Map<MstCharacterID, MstCharacter> | null =
    null;
  private static _MstCharacterAll: MstCharacter[] | null = null;

  /**
   * MstCharacterを全て取得
   * @returns MstCharacter[]
   */
  static getMstCharacterAll(): MstCharacter[] {
    if (this._MstCharacterAll === null) {
      this.loadMstCharacterData();
    }
    return this._MstCharacterAll!;
  }

  /**
   * MstCharacterをIDで取得
   * @param id MstCharacterID
   * @returns MstCharacter | undefined
   */
  static getMstCharacter(id: MstCharacterID): MstCharacter | undefined {
    if (this._MstCharacterCache === null) {
      this.loadMstCharacterData();
    }
    return this._MstCharacterCache!.get(id);
  }

  /**
   * MstCharacterをIDで取得（必須）
   * @param id MstCharacterID
   * @returns MstCharacter
   * @throws Error IDが見つからない場合
   */
  static mustGetMstCharacter(id: MstCharacterID): MstCharacter {
    const item = this.getMstCharacter(id);
    if (item === undefined) {
      throw new Error(`MstCharacter with ID ${id} not found`);
    }
    return item;
  }

  /**
   * MstCharacterデータをロード
   */
  private static loadMstCharacterData(): void {
    const items = MstCharacterData as MstCharacter[];

    // メソッドを追加
    const enhancedItems = items.map((item) => ({
      ...item,
      isAvailable: function (now?: Date): boolean {
        const currentTime = now || new Date();
        const beginTime = new Date(this.begin_date);
        const endTime = new Date(this.end_date);
        return currentTime > beginTime && currentTime < endTime;
      },
      isReleased: function (now?: Date): boolean {
        const currentTime = now || new Date();
        const beginTime = new Date(this.begin_date);
        return currentTime > beginTime;
      },
    }));

    this._MstCharacterAll = enhancedItems;
    this._MstCharacterCache = new Map();

    for (const item of enhancedItems) {
      this._MstCharacterCache.set(item.id as MstCharacterID, item);
    }
  }

  /**
   * MstCharacterデータをリロード
   */
  static reloadMstCharacterData(): void {
    this._MstCharacterCache = null;
    this._MstCharacterAll = null;
    this.loadMstCharacterData();
  }

  // MstCharacterBond 関連メソッド
  private static _MstCharacterBondCache: Map<
    MstCharacterBondID,
    MstCharacterBond
  > | null = null;
  private static _MstCharacterBondAll: MstCharacterBond[] | null = null;

  /**
   * MstCharacterBondを全て取得
   * @returns MstCharacterBond[]
   */
  static getMstCharacterBondAll(): MstCharacterBond[] {
    if (this._MstCharacterBondAll === null) {
      this.loadMstCharacterBondData();
    }
    return this._MstCharacterBondAll!;
  }

  /**
   * MstCharacterBondをIDで取得
   * @param id MstCharacterBondID
   * @returns MstCharacterBond | undefined
   */
  static getMstCharacterBond(
    id: MstCharacterBondID
  ): MstCharacterBond | undefined {
    if (this._MstCharacterBondCache === null) {
      this.loadMstCharacterBondData();
    }
    return this._MstCharacterBondCache!.get(id);
  }

  /**
   * MstCharacterBondをIDで取得（必須）
   * @param id MstCharacterBondID
   * @returns MstCharacterBond
   * @throws Error IDが見つからない場合
   */
  static mustGetMstCharacterBond(id: MstCharacterBondID): MstCharacterBond {
    const item = this.getMstCharacterBond(id);
    if (item === undefined) {
      throw new Error(`MstCharacterBond with ID ${id} not found`);
    }
    return item;
  }

  /**
   * MstCharacterBondデータをロード
   */
  private static loadMstCharacterBondData(): void {
    const items = MstCharacterBondData as MstCharacterBond[];

    // メソッドを追加
    const enhancedItems = items.map((item) => ({
      ...item,
      isAvailable: function (now?: Date): boolean {
        const currentTime = now || new Date();
        const beginTime = new Date(this.begin_date);
        const endTime = new Date(this.end_date);
        return currentTime > beginTime && currentTime < endTime;
      },
      isReleased: function (now?: Date): boolean {
        const currentTime = now || new Date();
        const beginTime = new Date(this.begin_date);
        return currentTime > beginTime;
      },
    }));

    this._MstCharacterBondAll = enhancedItems;
    this._MstCharacterBondCache = new Map();

    for (const item of enhancedItems) {
      this._MstCharacterBondCache.set(item.id as MstCharacterBondID, item);
    }
  }

  /**
   * MstCharacterBondデータをリロード
   */
  static reloadMstCharacterBondData(): void {
    this._MstCharacterBondCache = null;
    this._MstCharacterBondAll = null;
    this.loadMstCharacterBondData();
  }

  // MstCharacterProfile 関連メソッド
  private static _MstCharacterProfileCache: Map<
    MstCharacterProfileID,
    MstCharacterProfile
  > | null = null;
  private static _MstCharacterProfileAll: MstCharacterProfile[] | null = null;

  /**
   * MstCharacterProfileを全て取得
   * @returns MstCharacterProfile[]
   */
  static getMstCharacterProfileAll(): MstCharacterProfile[] {
    if (this._MstCharacterProfileAll === null) {
      this.loadMstCharacterProfileData();
    }
    return this._MstCharacterProfileAll!;
  }

  /**
   * MstCharacterProfileをIDで取得
   * @param id MstCharacterProfileID
   * @returns MstCharacterProfile | undefined
   */
  static getMstCharacterProfile(
    id: MstCharacterProfileID
  ): MstCharacterProfile | undefined {
    if (this._MstCharacterProfileCache === null) {
      this.loadMstCharacterProfileData();
    }
    return this._MstCharacterProfileCache!.get(id);
  }

  /**
   * MstCharacterProfileをIDで取得（必須）
   * @param id MstCharacterProfileID
   * @returns MstCharacterProfile
   * @throws Error IDが見つからない場合
   */
  static mustGetMstCharacterProfile(
    id: MstCharacterProfileID
  ): MstCharacterProfile {
    const item = this.getMstCharacterProfile(id);
    if (item === undefined) {
      throw new Error(`MstCharacterProfile with ID ${id} not found`);
    }
    return item;
  }

  /**
   * MstCharacterProfileデータをロード
   */
  private static loadMstCharacterProfileData(): void {
    const items = MstCharacterProfileData as MstCharacterProfile[];

    // メソッドを追加
    const enhancedItems = items.map((item) => ({
      ...item,
      isAvailable: function (now?: Date): boolean {
        const currentTime = now || new Date();
        const beginTime = new Date(this.begin_date);
        const endTime = new Date(this.end_date);
        return currentTime > beginTime && currentTime < endTime;
      },
      isReleased: function (now?: Date): boolean {
        const currentTime = now || new Date();
        const beginTime = new Date(this.begin_date);
        return currentTime > beginTime;
      },
    }));

    this._MstCharacterProfileAll = enhancedItems;
    this._MstCharacterProfileCache = new Map();

    for (const item of enhancedItems) {
      this._MstCharacterProfileCache.set(
        item.id as MstCharacterProfileID,
        item
      );
    }
  }

  /**
   * MstCharacterProfileデータをリロード
   */
  static reloadMstCharacterProfileData(): void {
    this._MstCharacterProfileCache = null;
    this._MstCharacterProfileAll = null;
    this.loadMstCharacterProfileData();
  }

  // MstCharacterSkin 関連メソッド
  private static _MstCharacterSkinCache: Map<
    MstCharacterSkinID,
    MstCharacterSkin
  > | null = null;
  private static _MstCharacterSkinAll: MstCharacterSkin[] | null = null;

  /**
   * MstCharacterSkinを全て取得
   * @returns MstCharacterSkin[]
   */
  static getMstCharacterSkinAll(): MstCharacterSkin[] {
    if (this._MstCharacterSkinAll === null) {
      this.loadMstCharacterSkinData();
    }
    return this._MstCharacterSkinAll!;
  }

  /**
   * MstCharacterSkinをIDで取得
   * @param id MstCharacterSkinID
   * @returns MstCharacterSkin | undefined
   */
  static getMstCharacterSkin(
    id: MstCharacterSkinID
  ): MstCharacterSkin | undefined {
    if (this._MstCharacterSkinCache === null) {
      this.loadMstCharacterSkinData();
    }
    return this._MstCharacterSkinCache!.get(id);
  }

  /**
   * MstCharacterSkinをIDで取得（必須）
   * @param id MstCharacterSkinID
   * @returns MstCharacterSkin
   * @throws Error IDが見つからない場合
   */
  static mustGetMstCharacterSkin(id: MstCharacterSkinID): MstCharacterSkin {
    const item = this.getMstCharacterSkin(id);
    if (item === undefined) {
      throw new Error(`MstCharacterSkin with ID ${id} not found`);
    }
    return item;
  }

  /**
   * MstCharacterSkinデータをロード
   */
  private static loadMstCharacterSkinData(): void {
    const items = MstCharacterSkinData as MstCharacterSkin[];

    // メソッドを追加
    const enhancedItems = items.map((item) => ({
      ...item,
      isAvailable: function (now?: Date): boolean {
        const currentTime = now || new Date();
        const beginTime = new Date(this.begin_date);
        const endTime = new Date(this.end_date);
        return currentTime > beginTime && currentTime < endTime;
      },
      isReleased: function (now?: Date): boolean {
        const currentTime = now || new Date();
        const beginTime = new Date(this.begin_date);
        return currentTime > beginTime;
      },
    }));

    this._MstCharacterSkinAll = enhancedItems;
    this._MstCharacterSkinCache = new Map();

    for (const item of enhancedItems) {
      this._MstCharacterSkinCache.set(item.id as MstCharacterSkinID, item);
    }
  }

  /**
   * MstCharacterSkinデータをリロード
   */
  static reloadMstCharacterSkinData(): void {
    this._MstCharacterSkinCache = null;
    this._MstCharacterSkinAll = null;
    this.loadMstCharacterSkinData();
  }

  // MstCurrency 関連メソッド
  private static _MstCurrencyCache: Map<MstCurrencyID, MstCurrency> | null =
    null;
  private static _MstCurrencyAll: MstCurrency[] | null = null;

  /**
   * MstCurrencyを全て取得
   * @returns MstCurrency[]
   */
  static getMstCurrencyAll(): MstCurrency[] {
    if (this._MstCurrencyAll === null) {
      this.loadMstCurrencyData();
    }
    return this._MstCurrencyAll!;
  }

  /**
   * MstCurrencyをIDで取得
   * @param id MstCurrencyID
   * @returns MstCurrency | undefined
   */
  static getMstCurrency(id: MstCurrencyID): MstCurrency | undefined {
    if (this._MstCurrencyCache === null) {
      this.loadMstCurrencyData();
    }
    return this._MstCurrencyCache!.get(id);
  }

  /**
   * MstCurrencyをIDで取得（必須）
   * @param id MstCurrencyID
   * @returns MstCurrency
   * @throws Error IDが見つからない場合
   */
  static mustGetMstCurrency(id: MstCurrencyID): MstCurrency {
    const item = this.getMstCurrency(id);
    if (item === undefined) {
      throw new Error(`MstCurrency with ID ${id} not found`);
    }
    return item;
  }

  /**
   * MstCurrencyデータをロード
   */
  private static loadMstCurrencyData(): void {
    const items = MstCurrencyData as unknown as Omit<
      MstCurrency,
      "version" | "isAvailable" | "isReleased"
    >[];

    // メソッドを追加
    const enhancedItems = items.map((item) => ({
      ...item,
      version: "",
      isAvailable: function (now?: Date): boolean {
        const currentTime = now || new Date();
        const beginTime = new Date(this.begin_date);
        const endTime = new Date(this.end_date);
        return currentTime > beginTime && currentTime < endTime;
      },
      isReleased: function (now?: Date): boolean {
        const currentTime = now || new Date();
        const beginTime = new Date(this.begin_date);
        return currentTime > beginTime;
      },
    })) as MstCurrency[];

    this._MstCurrencyAll = enhancedItems;
    this._MstCurrencyCache = new Map();

    for (const item of enhancedItems) {
      this._MstCurrencyCache.set(item.id as MstCurrencyID, item);
    }
  }

  /**
   * MstCurrencyデータをリロード
   */
  static reloadMstCurrencyData(): void {
    this._MstCurrencyCache = null;
    this._MstCurrencyAll = null;
    this.loadMstCurrencyData();
  }

  // MstErrorCode 関連メソッド
  private static _MstErrorCodeCache: Map<MstErrorCodeID, MstErrorCode> | null =
    null;
  private static _MstErrorCodeAll: MstErrorCode[] | null = null;

  /**
   * MstErrorCodeを全て取得
   * @returns MstErrorCode[]
   */
  static getMstErrorCodeAll(): MstErrorCode[] {
    if (this._MstErrorCodeAll === null) {
      this.loadMstErrorCodeData();
    }
    return this._MstErrorCodeAll!;
  }

  /**
   * MstErrorCodeをIDで取得
   * @param id MstErrorCodeID
   * @returns MstErrorCode | undefined
   */
  static getMstErrorCode(id: MstErrorCodeID): MstErrorCode | undefined {
    if (this._MstErrorCodeCache === null) {
      this.loadMstErrorCodeData();
    }
    return this._MstErrorCodeCache!.get(id);
  }

  /**
   * MstErrorCodeをIDで取得（必須）
   * @param id MstErrorCodeID
   * @returns MstErrorCode
   * @throws Error IDが見つからない場合
   */
  static mustGetMstErrorCode(id: MstErrorCodeID): MstErrorCode {
    const item = this.getMstErrorCode(id);
    if (item === undefined) {
      throw new Error(`MstErrorCode with ID ${id} not found`);
    }
    return item;
  }

  /**
   * MstErrorCodeデータをロード
   */
  private static loadMstErrorCodeData(): void {
    const items = MstErrorCodeData as MstErrorCode[];

    // メソッドを追加
    const enhancedItems = items.map((item) => ({
      ...item,
      isAvailable: function (now?: Date): boolean {
        const currentTime = now || new Date();
        const beginTime = new Date(this.begin_date);
        const endTime = new Date(this.end_date);
        return currentTime > beginTime && currentTime < endTime;
      },
      isReleased: function (now?: Date): boolean {
        const currentTime = now || new Date();
        const beginTime = new Date(this.begin_date);
        return currentTime > beginTime;
      },
    }));

    this._MstErrorCodeAll = enhancedItems;
    this._MstErrorCodeCache = new Map();

    for (const item of enhancedItems) {
      this._MstErrorCodeCache.set(item.id as MstErrorCodeID, item);
    }
  }

  /**
   * MstErrorCodeデータをリロード
   */
  static reloadMstErrorCodeData(): void {
    this._MstErrorCodeCache = null;
    this._MstErrorCodeAll = null;
    this.loadMstErrorCodeData();
  }

  /**
   * MstErrorCodeをエラーコードで取得
   * @param code エラーコード
   * @returns MstErrorCode[]
   */
  static getMstErrorCodeByCode(code: number): MstErrorCode[] {
    return this.getMstErrorCodeAll().filter((item) => item.code === code);
  }

  // MstHomeBackground 関連メソッド
  private static _MstHomeBackgroundCache: Map<
    MstHomeBackgroundID,
    MstHomeBackground
  > | null = null;
  private static _MstHomeBackgroundAll: MstHomeBackground[] | null = null;

  /**
   * MstHomeBackgroundを全て取得
   * @returns MstHomeBackground[]
   */
  static getMstHomeBackgroundAll(): MstHomeBackground[] {
    if (this._MstHomeBackgroundAll === null) {
      this.loadMstHomeBackgroundData();
    }
    return this._MstHomeBackgroundAll!;
  }

  /**
   * MstHomeBackgroundをIDで取得
   * @param id MstHomeBackgroundID
   * @returns MstHomeBackground | undefined
   */
  static getMstHomeBackground(
    id: MstHomeBackgroundID
  ): MstHomeBackground | undefined {
    if (this._MstHomeBackgroundCache === null) {
      this.loadMstHomeBackgroundData();
    }
    return this._MstHomeBackgroundCache!.get(id);
  }

  /**
   * MstHomeBackgroundをIDで取得（必須）
   * @param id MstHomeBackgroundID
   * @returns MstHomeBackground
   * @throws Error IDが見つからない場合
   */
  static mustGetMstHomeBackground(id: MstHomeBackgroundID): MstHomeBackground {
    const item = this.getMstHomeBackground(id);
    if (item === undefined) {
      throw new Error(`MstHomeBackground with ID ${id} not found`);
    }
    return item;
  }

  /**
   * MstHomeBackgroundデータをロード
   */
  private static loadMstHomeBackgroundData(): void {
    const items = MstHomeBackgroundData as MstHomeBackground[];

    // メソッドを追加
    const enhancedItems = items.map((item) => ({
      ...item,
      isAvailable: function (now?: Date): boolean {
        const currentTime = now || new Date();
        const beginTime = new Date(this.begin_date);
        const endTime = new Date(this.end_date);
        return currentTime > beginTime && currentTime < endTime;
      },
      isReleased: function (now?: Date): boolean {
        const currentTime = now || new Date();
        const beginTime = new Date(this.begin_date);
        return currentTime > beginTime;
      },
    }));

    this._MstHomeBackgroundAll = enhancedItems;
    this._MstHomeBackgroundCache = new Map();

    for (const item of enhancedItems) {
      this._MstHomeBackgroundCache.set(item.id as MstHomeBackgroundID, item);
    }
  }

  /**
   * MstHomeBackgroundデータをリロード
   */
  static reloadMstHomeBackgroundData(): void {
    this._MstHomeBackgroundCache = null;
    this._MstHomeBackgroundAll = null;
    this.loadMstHomeBackgroundData();
  }

  // MstIcon 関連メソッド
  private static _MstIconCache: Map<MstIconID, MstIcon> | null = null;
  private static _MstIconAll: MstIcon[] | null = null;

  /**
   * MstIconを全て取得
   * @returns MstIcon[]
   */
  static getMstIconAll(): MstIcon[] {
    if (this._MstIconAll === null) {
      this.loadMstIconData();
    }
    return this._MstIconAll!;
  }

  /**
   * MstIconをIDで取得
   * @param id MstIconID
   * @returns MstIcon | undefined
   */
  static getMstIcon(id: MstIconID): MstIcon | undefined {
    if (this._MstIconCache === null) {
      this.loadMstIconData();
    }
    return this._MstIconCache!.get(id);
  }

  /**
   * MstIconをIDで取得（必須）
   * @param id MstIconID
   * @returns MstIcon
   * @throws Error IDが見つからない場合
   */
  static mustGetMstIcon(id: MstIconID): MstIcon {
    const item = this.getMstIcon(id);
    if (item === undefined) {
      throw new Error(`MstIcon with ID ${id} not found`);
    }
    return item;
  }

  /**
   * MstIconデータをロード
   */
  private static loadMstIconData(): void {
    const items = MstIconData as MstIcon[];

    // メソッドを追加
    const enhancedItems = items.map((item) => ({
      ...item,
      isAvailable: function (now?: Date): boolean {
        const currentTime = now || new Date();
        const beginTime = new Date(this.begin_date);
        const endTime = new Date(this.end_date);
        return currentTime > beginTime && currentTime < endTime;
      },
      isReleased: function (now?: Date): boolean {
        const currentTime = now || new Date();
        const beginTime = new Date(this.begin_date);
        return currentTime > beginTime;
      },
    }));

    this._MstIconAll = enhancedItems;
    this._MstIconCache = new Map();

    for (const item of enhancedItems) {
      this._MstIconCache.set(item.id as MstIconID, item);
    }
  }

  /**
   * MstIconデータをリロード
   */
  static reloadMstIconData(): void {
    this._MstIconCache = null;
    this._MstIconAll = null;
    this.loadMstIconData();
  }

  // MstIconFrame 関連メソッド
  private static _MstIconFrameCache: Map<MstIconFrameID, MstIconFrame> | null =
    null;
  private static _MstIconFrameAll: MstIconFrame[] | null = null;

  /**
   * MstIconFrameを全て取得
   * @returns MstIconFrame[]
   */
  static getMstIconFrameAll(): MstIconFrame[] {
    if (this._MstIconFrameAll === null) {
      this.loadMstIconFrameData();
    }
    return this._MstIconFrameAll!;
  }

  /**
   * MstIconFrameをIDで取得
   * @param id MstIconFrameID
   * @returns MstIconFrame | undefined
   */
  static getMstIconFrame(id: MstIconFrameID): MstIconFrame | undefined {
    if (this._MstIconFrameCache === null) {
      this.loadMstIconFrameData();
    }
    return this._MstIconFrameCache!.get(id);
  }

  /**
   * MstIconFrameをIDで取得（必須）
   * @param id MstIconFrameID
   * @returns MstIconFrame
   * @throws Error IDが見つからない場合
   */
  static mustGetMstIconFrame(id: MstIconFrameID): MstIconFrame {
    const item = this.getMstIconFrame(id);
    if (item === undefined) {
      throw new Error(`MstIconFrame with ID ${id} not found`);
    }
    return item;
  }

  /**
   * MstIconFrameデータをロード
   */
  private static loadMstIconFrameData(): void {
    const items = MstIconFrameData as MstIconFrame[];

    // メソッドを追加
    const enhancedItems = items.map((item) => ({
      ...item,
      isAvailable: function (now?: Date): boolean {
        const currentTime = now || new Date();
        const beginTime = new Date(this.begin_date);
        const endTime = new Date(this.end_date);
        return currentTime > beginTime && currentTime < endTime;
      },
      isReleased: function (now?: Date): boolean {
        const currentTime = now || new Date();
        const beginTime = new Date(this.begin_date);
        return currentTime > beginTime;
      },
    }));

    this._MstIconFrameAll = enhancedItems;
    this._MstIconFrameCache = new Map();

    for (const item of enhancedItems) {
      this._MstIconFrameCache.set(item.id as MstIconFrameID, item);
    }
  }

  /**
   * MstIconFrameデータをリロード
   */
  static reloadMstIconFrameData(): void {
    this._MstIconFrameCache = null;
    this._MstIconFrameAll = null;
    this.loadMstIconFrameData();
  }

  // MstMission 関連メソッド
  private static _MstMissionCache: Map<MstMissionID, MstMission> | null = null;
  private static _MstMissionAll: MstMission[] | null = null;

  /**
   * MstMissionを全て取得
   * @returns MstMission[]
   */
  static getMstMissionAll(): MstMission[] {
    if (this._MstMissionAll === null) {
      this.loadMstMissionData();
    }
    return this._MstMissionAll!;
  }

  /**
   * MstMissionをIDで取得
   * @param id MstMissionID
   * @returns MstMission | undefined
   */
  static getMstMission(id: MstMissionID): MstMission | undefined {
    if (this._MstMissionCache === null) {
      this.loadMstMissionData();
    }
    return this._MstMissionCache!.get(id);
  }

  /**
   * MstMissionをIDで取得（必須）
   * @param id MstMissionID
   * @returns MstMission
   * @throws Error IDが見つからない場合
   */
  static mustGetMstMission(id: MstMissionID): MstMission {
    const item = this.getMstMission(id);
    if (item === undefined) {
      throw new Error(`MstMission with ID ${id} not found`);
    }
    return item;
  }

  /**
   * MstMissionデータをロード
   */
  private static loadMstMissionData(): void {
    const items = MstMissionData as MstMission[];

    // メソッドを追加
    const enhancedItems = items.map((item) => ({
      ...item,
      isAvailable: function (now?: Date): boolean {
        const currentTime = now || new Date();
        const beginTime = new Date(this.begin_date);
        const endTime = new Date(this.end_date);
        return currentTime > beginTime && currentTime < endTime;
      },
      isReleased: function (now?: Date): boolean {
        const currentTime = now || new Date();
        const beginTime = new Date(this.begin_date);
        return currentTime > beginTime;
      },
    }));

    this._MstMissionAll = enhancedItems;
    this._MstMissionCache = new Map();

    for (const item of enhancedItems) {
      this._MstMissionCache.set(item.id as MstMissionID, item);
    }
  }

  /**
   * MstMissionデータをリロード
   */
  static reloadMstMissionData(): void {
    this._MstMissionCache = null;
    this._MstMissionAll = null;
    this.loadMstMissionData();
  }

  // MstPaidShop 関連メソッド
  private static _MstPaidShopCache: Map<MstPaidShopID, MstPaidShop> | null =
    null;
  private static _MstPaidShopAll: MstPaidShop[] | null = null;

  /**
   * MstPaidShopを全て取得
   * @returns MstPaidShop[]
   */
  static getMstPaidShopAll(): MstPaidShop[] {
    if (this._MstPaidShopAll === null) {
      this.loadMstPaidShopData();
    }
    return this._MstPaidShopAll!;
  }

  /**
   * MstPaidShopをIDで取得
   * @param id MstPaidShopID
   * @returns MstPaidShop | undefined
   */
  static getMstPaidShop(id: MstPaidShopID): MstPaidShop | undefined {
    if (this._MstPaidShopCache === null) {
      this.loadMstPaidShopData();
    }
    return this._MstPaidShopCache!.get(id);
  }

  /**
   * MstPaidShopをIDで取得（必須）
   * @param id MstPaidShopID
   * @returns MstPaidShop
   * @throws Error IDが見つからない場合
   */
  static mustGetMstPaidShop(id: MstPaidShopID): MstPaidShop {
    const item = this.getMstPaidShop(id);
    if (item === undefined) {
      throw new Error(`MstPaidShop with ID ${id} not found`);
    }
    return item;
  }

  /**
   * MstPaidShopデータをロード
   */
  private static loadMstPaidShopData(): void {
    const items = MstPaidShopData as MstPaidShop[];

    // メソッドを追加
    const enhancedItems = items.map((item) => ({
      ...item,
      isAvailable: function (now?: Date): boolean {
        const currentTime = now || new Date();
        const beginTime = new Date(this.begin_date);
        const endTime = new Date(this.end_date);
        return currentTime > beginTime && currentTime < endTime;
      },
      isReleased: function (now?: Date): boolean {
        const currentTime = now || new Date();
        const beginTime = new Date(this.begin_date);
        return currentTime > beginTime;
      },
    }));

    this._MstPaidShopAll = enhancedItems;
    this._MstPaidShopCache = new Map();

    for (const item of enhancedItems) {
      this._MstPaidShopCache.set(item.id as MstPaidShopID, item);
    }
  }

  /**
   * MstPaidShopデータをリロード
   */
  static reloadMstPaidShopData(): void {
    this._MstPaidShopCache = null;
    this._MstPaidShopAll = null;
    this.loadMstPaidShopData();
  }

  // MstPaidShopBundleSet 関連メソッド
  private static _MstPaidShopBundleSetCache: Map<
    MstPaidShopBundleSetID,
    MstPaidShopBundleSet
  > | null = null;
  private static _MstPaidShopBundleSetAll: MstPaidShopBundleSet[] | null = null;

  /**
   * MstPaidShopBundleSetを全て取得
   * @returns MstPaidShopBundleSet[]
   */
  static getMstPaidShopBundleSetAll(): MstPaidShopBundleSet[] {
    if (this._MstPaidShopBundleSetAll === null) {
      this.loadMstPaidShopBundleSetData();
    }
    return this._MstPaidShopBundleSetAll!;
  }

  /**
   * MstPaidShopBundleSetをIDで取得
   * @param id MstPaidShopBundleSetID
   * @returns MstPaidShopBundleSet | undefined
   */
  static getMstPaidShopBundleSet(
    id: MstPaidShopBundleSetID
  ): MstPaidShopBundleSet | undefined {
    if (this._MstPaidShopBundleSetCache === null) {
      this.loadMstPaidShopBundleSetData();
    }
    return this._MstPaidShopBundleSetCache!.get(id);
  }

  /**
   * MstPaidShopBundleSetをIDで取得（必須）
   * @param id MstPaidShopBundleSetID
   * @returns MstPaidShopBundleSet
   * @throws Error IDが見つからない場合
   */
  static mustGetMstPaidShopBundleSet(
    id: MstPaidShopBundleSetID
  ): MstPaidShopBundleSet {
    const item = this.getMstPaidShopBundleSet(id);
    if (item === undefined) {
      throw new Error(`MstPaidShopBundleSet with ID ${id} not found`);
    }
    return item;
  }

  /**
   * MstPaidShopBundleSetデータをロード
   */
  private static loadMstPaidShopBundleSetData(): void {
    const items = MstPaidShopBundleSetData as MstPaidShopBundleSet[];

    // メソッドを追加
    const enhancedItems = items.map((item) => ({
      ...item,
      isAvailable: function (now?: Date): boolean {
        const currentTime = now || new Date();
        const beginTime = new Date(this.begin_date);
        const endTime = new Date(this.end_date);
        return currentTime > beginTime && currentTime < endTime;
      },
      isReleased: function (now?: Date): boolean {
        const currentTime = now || new Date();
        const beginTime = new Date(this.begin_date);
        return currentTime > beginTime;
      },
    }));

    this._MstPaidShopBundleSetAll = enhancedItems;
    this._MstPaidShopBundleSetCache = new Map();

    for (const item of enhancedItems) {
      this._MstPaidShopBundleSetCache.set(
        item.id as MstPaidShopBundleSetID,
        item
      );
    }
  }

  /**
   * MstPaidShopBundleSetデータをリロード
   */
  static reloadMstPaidShopBundleSetData(): void {
    this._MstPaidShopBundleSetCache = null;
    this._MstPaidShopBundleSetAll = null;
    this.loadMstPaidShopBundleSetData();
  }

  // MstSeason 関連メソッド
  private static _MstSeasonCache: Map<MstSeasonID, MstSeason> | null = null;
  private static _MstSeasonAll: MstSeason[] | null = null;

  /**
   * MstSeasonを全て取得
   * @returns MstSeason[]
   */
  static getMstSeasonAll(): MstSeason[] {
    if (this._MstSeasonAll === null) {
      this.loadMstSeasonData();
    }
    return this._MstSeasonAll!;
  }

  /**
   * MstSeasonをIDで取得
   * @param id MstSeasonID
   * @returns MstSeason | undefined
   */
  static getMstSeason(id: MstSeasonID): MstSeason | undefined {
    if (this._MstSeasonCache === null) {
      this.loadMstSeasonData();
    }
    return this._MstSeasonCache!.get(id);
  }

  /**
   * MstSeasonをIDで取得（必須）
   * @param id MstSeasonID
   * @returns MstSeason
   * @throws Error IDが見つからない場合
   */
  static mustGetMstSeason(id: MstSeasonID): MstSeason {
    const item = this.getMstSeason(id);
    if (item === undefined) {
      throw new Error(`MstSeason with ID ${id} not found`);
    }
    return item;
  }

  /**
   * MstSeasonデータをロード
   */
  private static loadMstSeasonData(): void {
    const items = MstSeasonData as MstSeason[];

    // メソッドを追加
    const enhancedItems = items.map((item) => ({
      ...item,
      isAvailable: function (now?: Date): boolean {
        const currentTime = now || new Date();
        const beginTime = new Date(this.begin_date);
        const endTime = new Date(this.end_date);
        return currentTime > beginTime && currentTime < endTime;
      },
      isReleased: function (now?: Date): boolean {
        const currentTime = now || new Date();
        const beginTime = new Date(this.begin_date);
        return currentTime > beginTime;
      },
    }));

    this._MstSeasonAll = enhancedItems;
    this._MstSeasonCache = new Map();

    for (const item of enhancedItems) {
      this._MstSeasonCache.set(item.id as MstSeasonID, item);
    }
  }

  /**
   * MstSeasonデータをリロード
   */
  static reloadMstSeasonData(): void {
    this._MstSeasonCache = null;
    this._MstSeasonAll = null;
    this.loadMstSeasonData();
  }

  // MstShogiBoard 関連メソッド
  private static _MstShogiBoardCache: Map<
    MstShogiBoardID,
    MstShogiBoard
  > | null = null;
  private static _MstShogiBoardAll: MstShogiBoard[] | null = null;

  /**
   * MstShogiBoardを全て取得
   * @returns MstShogiBoard[]
   */
  static getMstShogiBoardAll(): MstShogiBoard[] {
    if (this._MstShogiBoardAll === null) {
      this.loadMstShogiBoardData();
    }
    return this._MstShogiBoardAll!;
  }

  /**
   * MstShogiBoardをIDで取得
   * @param id MstShogiBoardID
   * @returns MstShogiBoard | undefined
   */
  static getMstShogiBoard(id: MstShogiBoardID): MstShogiBoard | undefined {
    if (this._MstShogiBoardCache === null) {
      this.loadMstShogiBoardData();
    }
    return this._MstShogiBoardCache!.get(id);
  }

  /**
   * MstShogiBoardをIDで取得（必須）
   * @param id MstShogiBoardID
   * @returns MstShogiBoard
   * @throws Error IDが見つからない場合
   */
  static mustGetMstShogiBoard(id: MstShogiBoardID): MstShogiBoard {
    const item = this.getMstShogiBoard(id);
    if (item === undefined) {
      throw new Error(`MstShogiBoard with ID ${id} not found`);
    }
    return item;
  }

  /**
   * MstShogiBoardデータをロード
   */
  private static loadMstShogiBoardData(): void {
    const items = MstShogiBoardData as MstShogiBoard[];

    // メソッドを追加
    const enhancedItems = items.map((item) => ({
      ...item,
      isAvailable: function (now?: Date): boolean {
        const currentTime = now || new Date();
        const beginTime = new Date(this.begin_date);
        const endTime = new Date(this.end_date);
        return currentTime > beginTime && currentTime < endTime;
      },
      isReleased: function (now?: Date): boolean {
        const currentTime = now || new Date();
        const beginTime = new Date(this.begin_date);
        return currentTime > beginTime;
      },
    }));

    this._MstShogiBoardAll = enhancedItems;
    this._MstShogiBoardCache = new Map();

    for (const item of enhancedItems) {
      this._MstShogiBoardCache.set(item.id as MstShogiBoardID, item);
    }
  }

  /**
   * MstShogiBoardデータをリロード
   */
  static reloadMstShogiBoardData(): void {
    this._MstShogiBoardCache = null;
    this._MstShogiBoardAll = null;
    this.loadMstShogiBoardData();
  }

  // MstShogiIngameBGM 関連メソッド
  private static _MstShogiIngameBGMCache: Map<
    MstShogiIngameBGMID,
    MstShogiIngameBGM
  > | null = null;
  private static _MstShogiIngameBGMAll: MstShogiIngameBGM[] | null = null;

  /**
   * MstShogiIngameBGMを全て取得
   * @returns MstShogiIngameBGM[]
   */
  static getMstShogiIngameBGMAll(): MstShogiIngameBGM[] {
    if (this._MstShogiIngameBGMAll === null) {
      this.loadMstShogiIngameBGMData();
    }
    return this._MstShogiIngameBGMAll!;
  }

  /**
   * MstShogiIngameBGMをIDで取得
   * @param id MstShogiIngameBGMID
   * @returns MstShogiIngameBGM | undefined
   */
  static getMstShogiIngameBGM(
    id: MstShogiIngameBGMID
  ): MstShogiIngameBGM | undefined {
    if (this._MstShogiIngameBGMCache === null) {
      this.loadMstShogiIngameBGMData();
    }
    return this._MstShogiIngameBGMCache!.get(id);
  }

  /**
   * MstShogiIngameBGMをIDで取得（必須）
   * @param id MstShogiIngameBGMID
   * @returns MstShogiIngameBGM
   * @throws Error IDが見つからない場合
   */
  static mustGetMstShogiIngameBGM(id: MstShogiIngameBGMID): MstShogiIngameBGM {
    const item = this.getMstShogiIngameBGM(id);
    if (item === undefined) {
      throw new Error(`MstShogiIngameBGM with ID ${id} not found`);
    }
    return item;
  }

  /**
   * MstShogiIngameBGMデータをロード
   */
  private static loadMstShogiIngameBGMData(): void {
    const items = MstShogiIngameBGMData as MstShogiIngameBGM[];

    // メソッドを追加
    const enhancedItems = items.map((item) => ({
      ...item,
      isAvailable: function (now?: Date): boolean {
        const currentTime = now || new Date();
        const beginTime = new Date(this.begin_date);
        const endTime = new Date(this.end_date);
        return currentTime > beginTime && currentTime < endTime;
      },
      isReleased: function (now?: Date): boolean {
        const currentTime = now || new Date();
        const beginTime = new Date(this.begin_date);
        return currentTime > beginTime;
      },
    }));

    this._MstShogiIngameBGMAll = enhancedItems;
    this._MstShogiIngameBGMCache = new Map();

    for (const item of enhancedItems) {
      this._MstShogiIngameBGMCache.set(item.id as MstShogiIngameBGMID, item);
    }
  }

  /**
   * MstShogiIngameBGMデータをリロード
   */
  static reloadMstShogiIngameBGMData(): void {
    this._MstShogiIngameBGMCache = null;
    this._MstShogiIngameBGMAll = null;
    this.loadMstShogiIngameBGMData();
  }

  // MstShogiPiece 関連メソッド
  private static _MstShogiPieceCache: Map<
    MstShogiPieceID,
    MstShogiPiece
  > | null = null;
  private static _MstShogiPieceAll: MstShogiPiece[] | null = null;

  /**
   * MstShogiPieceを全て取得
   * @returns MstShogiPiece[]
   */
  static getMstShogiPieceAll(): MstShogiPiece[] {
    if (this._MstShogiPieceAll === null) {
      this.loadMstShogiPieceData();
    }
    return this._MstShogiPieceAll!;
  }

  /**
   * MstShogiPieceをIDで取得
   * @param id MstShogiPieceID
   * @returns MstShogiPiece | undefined
   */
  static getMstShogiPiece(id: MstShogiPieceID): MstShogiPiece | undefined {
    if (this._MstShogiPieceCache === null) {
      this.loadMstShogiPieceData();
    }
    return this._MstShogiPieceCache!.get(id);
  }

  /**
   * MstShogiPieceをIDで取得（必須）
   * @param id MstShogiPieceID
   * @returns MstShogiPiece
   * @throws Error IDが見つからない場合
   */
  static mustGetMstShogiPiece(id: MstShogiPieceID): MstShogiPiece {
    const item = this.getMstShogiPiece(id);
    if (item === undefined) {
      throw new Error(`MstShogiPiece with ID ${id} not found`);
    }
    return item;
  }

  /**
   * MstShogiPieceデータをロード
   */
  private static loadMstShogiPieceData(): void {
    const items = MstShogiPieceData as MstShogiPiece[];

    // メソッドを追加
    const enhancedItems = items.map((item) => ({
      ...item,
      isAvailable: function (now?: Date): boolean {
        const currentTime = now || new Date();
        const beginTime = new Date(this.begin_date);
        const endTime = new Date(this.end_date);
        return currentTime > beginTime && currentTime < endTime;
      },
      isReleased: function (now?: Date): boolean {
        const currentTime = now || new Date();
        const beginTime = new Date(this.begin_date);
        return currentTime > beginTime;
      },
    }));

    this._MstShogiPieceAll = enhancedItems;
    this._MstShogiPieceCache = new Map();

    for (const item of enhancedItems) {
      this._MstShogiPieceCache.set(item.id as MstShogiPieceID, item);
    }
  }

  /**
   * MstShogiPieceデータをリロード
   */
  static reloadMstShogiPieceData(): void {
    this._MstShogiPieceCache = null;
    this._MstShogiPieceAll = null;
    this.loadMstShogiPieceData();
  }

  // MstShogiPieceEffect 関連メソッド
  private static _MstShogiPieceEffectCache: Map<
    MstShogiPieceEffectID,
    MstShogiPieceEffect
  > | null = null;
  private static _MstShogiPieceEffectAll: MstShogiPieceEffect[] | null = null;

  /**
   * MstShogiPieceEffectを全て取得
   * @returns MstShogiPieceEffect[]
   */
  static getMstShogiPieceEffectAll(): MstShogiPieceEffect[] {
    if (this._MstShogiPieceEffectAll === null) {
      this.loadMstShogiPieceEffectData();
    }
    return this._MstShogiPieceEffectAll!;
  }

  /**
   * MstShogiPieceEffectをIDで取得
   * @param id MstShogiPieceEffectID
   * @returns MstShogiPieceEffect | undefined
   */
  static getMstShogiPieceEffect(
    id: MstShogiPieceEffectID
  ): MstShogiPieceEffect | undefined {
    if (this._MstShogiPieceEffectCache === null) {
      this.loadMstShogiPieceEffectData();
    }
    return this._MstShogiPieceEffectCache!.get(id);
  }

  /**
   * MstShogiPieceEffectをIDで取得（必須）
   * @param id MstShogiPieceEffectID
   * @returns MstShogiPieceEffect
   * @throws Error IDが見つからない場合
   */
  static mustGetMstShogiPieceEffect(
    id: MstShogiPieceEffectID
  ): MstShogiPieceEffect {
    const item = this.getMstShogiPieceEffect(id);
    if (item === undefined) {
      throw new Error(`MstShogiPieceEffect with ID ${id} not found`);
    }
    return item;
  }

  /**
   * MstShogiPieceEffectデータをロード
   */
  private static loadMstShogiPieceEffectData(): void {
    const items = MstShogiPieceEffectData as MstShogiPieceEffect[];

    // メソッドを追加
    const enhancedItems = items.map((item) => ({
      ...item,
      isAvailable: function (now?: Date): boolean {
        const currentTime = now || new Date();
        const beginTime = new Date(this.begin_date);
        const endTime = new Date(this.end_date);
        return currentTime > beginTime && currentTime < endTime;
      },
      isReleased: function (now?: Date): boolean {
        const currentTime = now || new Date();
        const beginTime = new Date(this.begin_date);
        return currentTime > beginTime;
      },
    }));

    this._MstShogiPieceEffectAll = enhancedItems;
    this._MstShogiPieceEffectCache = new Map();

    for (const item of enhancedItems) {
      this._MstShogiPieceEffectCache.set(
        item.id as MstShogiPieceEffectID,
        item
      );
    }
  }

  /**
   * MstShogiPieceEffectデータをリロード
   */
  static reloadMstShogiPieceEffectData(): void {
    this._MstShogiPieceEffectCache = null;
    this._MstShogiPieceEffectAll = null;
    this.loadMstShogiPieceEffectData();
  }

  // MstShogiPieceSound 関連メソッド
  private static _MstShogiPieceSoundCache: Map<
    MstShogiPieceSoundID,
    MstShogiPieceSound
  > | null = null;
  private static _MstShogiPieceSoundAll: MstShogiPieceSound[] | null = null;

  /**
   * MstShogiPieceSoundを全て取得
   * @returns MstShogiPieceSound[]
   */
  static getMstShogiPieceSoundAll(): MstShogiPieceSound[] {
    if (this._MstShogiPieceSoundAll === null) {
      this.loadMstShogiPieceSoundData();
    }
    return this._MstShogiPieceSoundAll!;
  }

  /**
   * MstShogiPieceSoundをIDで取得
   * @param id MstShogiPieceSoundID
   * @returns MstShogiPieceSound | undefined
   */
  static getMstShogiPieceSound(
    id: MstShogiPieceSoundID
  ): MstShogiPieceSound | undefined {
    if (this._MstShogiPieceSoundCache === null) {
      this.loadMstShogiPieceSoundData();
    }
    return this._MstShogiPieceSoundCache!.get(id);
  }

  /**
   * MstShogiPieceSoundをIDで取得（必須）
   * @param id MstShogiPieceSoundID
   * @returns MstShogiPieceSound
   * @throws Error IDが見つからない場合
   */
  static mustGetMstShogiPieceSound(
    id: MstShogiPieceSoundID
  ): MstShogiPieceSound {
    const item = this.getMstShogiPieceSound(id);
    if (item === undefined) {
      throw new Error(`MstShogiPieceSound with ID ${id} not found`);
    }
    return item;
  }

  /**
   * MstShogiPieceSoundデータをロード
   */
  private static loadMstShogiPieceSoundData(): void {
    const items = MstShogiPieceSoundData as MstShogiPieceSound[];

    // メソッドを追加
    const enhancedItems = items.map((item) => ({
      ...item,
      isAvailable: function (now?: Date): boolean {
        const currentTime = now || new Date();
        const beginTime = new Date(this.begin_date);
        const endTime = new Date(this.end_date);
        return currentTime > beginTime && currentTime < endTime;
      },
      isReleased: function (now?: Date): boolean {
        const currentTime = now || new Date();
        const beginTime = new Date(this.begin_date);
        return currentTime > beginTime;
      },
    }));

    this._MstShogiPieceSoundAll = enhancedItems;
    this._MstShogiPieceSoundCache = new Map();

    for (const item of enhancedItems) {
      this._MstShogiPieceSoundCache.set(item.id as MstShogiPieceSoundID, item);
    }
  }

  /**
   * MstShogiPieceSoundデータをリロード
   */
  static reloadMstShogiPieceSoundData(): void {
    this._MstShogiPieceSoundCache = null;
    this._MstShogiPieceSoundAll = null;
    this.loadMstShogiPieceSoundData();
  }

  // MstSubscriptionPlan 関連メソッド
  private static _MstSubscriptionPlanCache: Map<
    MstSubscriptionPlanID,
    MstSubscriptionPlan
  > | null = null;
  private static _MstSubscriptionPlanAll: MstSubscriptionPlan[] | null = null;

  /**
   * MstSubscriptionPlanを全て取得
   * @returns MstSubscriptionPlan[]
   */
  static getMstSubscriptionPlanAll(): MstSubscriptionPlan[] {
    if (this._MstSubscriptionPlanAll === null) {
      this.loadMstSubscriptionPlanData();
    }
    return this._MstSubscriptionPlanAll!;
  }

  /**
   * MstSubscriptionPlanをIDで取得
   * @param id MstSubscriptionPlanID
   * @returns MstSubscriptionPlan | undefined
   */
  static getMstSubscriptionPlan(
    id: MstSubscriptionPlanID
  ): MstSubscriptionPlan | undefined {
    if (this._MstSubscriptionPlanCache === null) {
      this.loadMstSubscriptionPlanData();
    }
    return this._MstSubscriptionPlanCache!.get(id);
  }

  /**
   * MstSubscriptionPlanをIDで取得（必須）
   * @param id MstSubscriptionPlanID
   * @returns MstSubscriptionPlan
   * @throws Error IDが見つからない場合
   */
  static mustGetMstSubscriptionPlan(
    id: MstSubscriptionPlanID
  ): MstSubscriptionPlan {
    const item = this.getMstSubscriptionPlan(id);
    if (item === undefined) {
      throw new Error(`MstSubscriptionPlan with ID ${id} not found`);
    }
    return item;
  }

  /**
   * MstSubscriptionPlanデータをロード
   */
  private static loadMstSubscriptionPlanData(): void {
    const items = MstSubscriptionPlanData as MstSubscriptionPlan[];

    // メソッドを追加
    const enhancedItems = items.map((item) => ({
      ...item,
      isAvailable: function (now?: Date): boolean {
        const currentTime = now || new Date();
        const beginTime = new Date(this.begin_date);
        const endTime = new Date(this.end_date);
        return currentTime > beginTime && currentTime < endTime;
      },
      isReleased: function (now?: Date): boolean {
        const currentTime = now || new Date();
        const beginTime = new Date(this.begin_date);
        return currentTime > beginTime;
      },
    }));

    this._MstSubscriptionPlanAll = enhancedItems;
    this._MstSubscriptionPlanCache = new Map();

    for (const item of enhancedItems) {
      this._MstSubscriptionPlanCache.set(
        item.id as MstSubscriptionPlanID,
        item
      );
    }
  }

  /**
   * MstSubscriptionPlanデータをリロード
   */
  static reloadMstSubscriptionPlanData(): void {
    this._MstSubscriptionPlanCache = null;
    this._MstSubscriptionPlanAll = null;
    this.loadMstSubscriptionPlanData();
  }

  /**
   * 全マスターデータをリロード
   */
  static reloadAllData(): void {
    this.reloadMstAchievementData();
    this.reloadMstAssetVersionData();
    this.reloadMstCharacterData();
    this.reloadMstCharacterBondData();
    this.reloadMstCharacterProfileData();
    this.reloadMstCharacterSkinData();
    this.reloadMstCurrencyData();
    this.reloadMstErrorCodeData();
    this.reloadMstHomeBackgroundData();
    this.reloadMstIconData();
    this.reloadMstIconFrameData();
    this.reloadMstMissionData();
    this.reloadMstPaidShopData();
    this.reloadMstPaidShopBundleSetData();
    this.reloadMstSeasonData();
    this.reloadMstShogiBoardData();
    this.reloadMstShogiIngameBGMData();
    this.reloadMstShogiPieceData();
    this.reloadMstShogiPieceEffectData();
    this.reloadMstShogiPieceSoundData();
    this.reloadMstSubscriptionPlanData();
  }

  /**
   * マスターデータの統計情報を取得
   */
  static getStatistics(): { [key: string]: number } {
    return {
      mstAchievement: this.getMstAchievementAll().length,
      mstAssetVersion: this.getMstAssetVersionAll().length,
      mstCharacter: this.getMstCharacterAll().length,
      mstCharacterBond: this.getMstCharacterBondAll().length,
      mstCharacterProfile: this.getMstCharacterProfileAll().length,
      mstCharacterSkin: this.getMstCharacterSkinAll().length,
      mstCurrency: this.getMstCurrencyAll().length,
      mstErrorCode: this.getMstErrorCodeAll().length,
      mstHomeBackground: this.getMstHomeBackgroundAll().length,
      mstIcon: this.getMstIconAll().length,
      mstIconFrame: this.getMstIconFrameAll().length,
      mstMission: this.getMstMissionAll().length,
      mstPaidShop: this.getMstPaidShopAll().length,
      mstPaidShopBundleSet: this.getMstPaidShopBundleSetAll().length,
      mstSeason: this.getMstSeasonAll().length,
      mstShogiBoard: this.getMstShogiBoardAll().length,
      mstShogiIngameBGM: this.getMstShogiIngameBGMAll().length,
      mstShogiPiece: this.getMstShogiPieceAll().length,
      mstShogiPieceEffect: this.getMstShogiPieceEffectAll().length,
      mstShogiPieceSound: this.getMstShogiPieceSoundAll().length,
      mstSubscriptionPlan: this.getMstSubscriptionPlanAll().length,
    };
  }
}

// 便利な検索メソッド
export class MasterDataSearcher {
  /**
   * MstAchievementをアセットバージョンで検索
   * @param assetVersion 検索するアセットバージョン
   * @returns MstAchievement[]
   */
  static searchMstAchievementByAssetVersion(
    assetVersion: string
  ): MstAchievement[] {
    return MasterDataClient.getMstAchievementAll().filter((item) =>
      item.asset_version?.includes(assetVersion)
    );
  }

  /**
   * MstAchievementをで検索
   * @param name 検索する
   * @returns MstAchievement[]
   */
  static searchMstAchievementByName(name: string): MstAchievement[] {
    return MasterDataClient.getMstAchievementAll().filter((item) =>
      item.name?.includes(name)
    );
  }

  /**
   * MstAssetVersionをAppバージョンで検索
   * @param appVersion 検索するAppバージョン
   * @returns MstAssetVersion[]
   */
  static searchMstAssetVersionByAppVersion(
    appVersion: string
  ): MstAssetVersion[] {
    return MasterDataClient.getMstAssetVersionAll().filter((item) =>
      item.app_version?.includes(appVersion)
    );
  }

  /**
   * MstAssetVersionをアセットバージョンで検索
   * @param assetVersion 検索するアセットバージョン
   * @returns MstAssetVersion[]
   */
  static searchMstAssetVersionByAssetVersion(
    assetVersion: string
  ): MstAssetVersion[] {
    return MasterDataClient.getMstAssetVersionAll().filter((item) =>
      item.asset_version?.includes(assetVersion)
    );
  }

  /**
   * MstAssetVersionをOS種別で検索
   * @param osType 検索するOS種別
   * @returns MstAssetVersion[]
   */
  static searchMstAssetVersionByOSType(osType: string): MstAssetVersion[] {
    return MasterDataClient.getMstAssetVersionAll().filter((item) =>
      item.os_type?.includes(osType)
    );
  }

  /**
   * MstCharacterをアセットバージョンで検索
   * @param assetVersion 検索するアセットバージョン
   * @returns MstCharacter[]
   */
  static searchMstCharacterByAssetVersion(
    assetVersion: string
  ): MstCharacter[] {
    return MasterDataClient.getMstCharacterAll().filter((item) =>
      item.asset_version?.includes(assetVersion)
    );
  }

  /**
   * MstCharacterをキャラクター名で検索
   * @param name 検索するキャラクター名
   * @returns MstCharacter[]
   */
  static searchMstCharacterByName(name: string): MstCharacter[] {
    return MasterDataClient.getMstCharacterAll().filter((item) =>
      item.name?.includes(name)
    );
  }

  /**
   * MstCharacterを好みの贈り物の通貨マスタIDリストで検索
   * @param preferredPresentIDList 検索する好みの贈り物の通貨マスタIDリスト
   * @returns MstCharacter[]
   */
  static searchMstCharacterByPreferredPresentIDList(
    preferredPresentIDList: number
  ): MstCharacter[] {
    return MasterDataClient.getMstCharacterAll().filter((item) =>
      item.preferred_present_id_list?.includes(preferredPresentIDList)
    );
  }

  /**
   * MstCharacterBondをアセットバージョンで検索
   * @param assetVersion 検索するアセットバージョン
   * @returns MstCharacterBond[]
   */
  static searchMstCharacterBondByAssetVersion(
    assetVersion: string
  ): MstCharacterBond[] {
    return MasterDataClient.getMstCharacterBondAll().filter((item) =>
      item.asset_version?.includes(assetVersion)
    );
  }

  /**
   * MstCharacterBondを契約に必要なアイテム個数リストで検索
   * @param contractItemAmountList 検索する契約に必要なアイテム個数リスト
   * @returns MstCharacterBond[]
   */
  static searchMstCharacterBondByContractItemAmountList(
    contractItemAmountList: number
  ): MstCharacterBond[] {
    return MasterDataClient.getMstCharacterBondAll().filter((item) =>
      item.contract_item_amount_list?.includes(contractItemAmountList)
    );
  }

  /**
   * MstCharacterBondを契約に必要なアイテム種別リストで検索
   * @param contractItemTypeList 検索する契約に必要なアイテム種別リスト
   * @returns MstCharacterBond[]
   */
  static searchMstCharacterBondByContractItemTypeList(
    contractItemTypeList: string
  ): MstCharacterBond[] {
    return MasterDataClient.getMstCharacterBondAll().filter((item) =>
      item.contract_item_type_list?.includes(contractItemTypeList)
    );
  }

  /**
   * MstCharacterBondをで検索
   * @param contractOptionList 検索する
   * @returns MstCharacterBond[]
   */
  static searchMstCharacterBondByContractOptionList(
    contractOptionList: string
  ): MstCharacterBond[] {
    return MasterDataClient.getMstCharacterBondAll().filter((item) =>
      item.contract_option_list?.includes(contractOptionList)
    );
  }

  /**
   * MstCharacterBondを絆レベルリストで検索
   * @param levelList 検索する絆レベルリスト
   * @returns MstCharacterBond[]
   */
  static searchMstCharacterBondByLevelList(
    levelList: number
  ): MstCharacterBond[] {
    return MasterDataClient.getMstCharacterBondAll().filter((item) =>
      item.level_list?.includes(levelList)
    );
  }

  /**
   * MstCharacterBondをキャラクターマスタIDで検索
   * @param mstCharacterID 検索するキャラクターマスタID
   * @returns MstCharacterBond[]
   */
  static searchMstCharacterBondByMstCharacterID(
    mstCharacterID: number
  ): MstCharacterBond[] {
    return MasterDataClient.getMstCharacterBondAll().filter(
      (item) => item.mst_character_id === mstCharacterID
    );
  }

  /**
   * MstCharacterBondを必要経験値リストで検索
   * @param needExpList 検索する必要経験値リスト
   * @returns MstCharacterBond[]
   */
  static searchMstCharacterBondByNeedExpList(
    needExpList: number
  ): MstCharacterBond[] {
    return MasterDataClient.getMstCharacterBondAll().filter((item) =>
      item.need_exp_list?.includes(needExpList)
    );
  }

  /**
   * MstCharacterProfileをアセットバージョンで検索
   * @param assetVersion 検索するアセットバージョン
   * @returns MstCharacterProfile[]
   */
  static searchMstCharacterProfileByAssetVersion(
    assetVersion: string
  ): MstCharacterProfile[] {
    return MasterDataClient.getMstCharacterProfileAll().filter((item) =>
      item.asset_version?.includes(assetVersion)
    );
  }

  /**
   * MstCharacterProfileをキャラクターマスタIDで検索
   * @param mstCharacterID 検索するキャラクターマスタID
   * @returns MstCharacterProfile[]
   */
  static searchMstCharacterProfileByMstCharacterID(
    mstCharacterID: number
  ): MstCharacterProfile[] {
    return MasterDataClient.getMstCharacterProfileAll().filter(
      (item) => item.mst_character_id === mstCharacterID
    );
  }

  /**
   * MstCharacterSkinをアセットバージョンで検索
   * @param assetVersion 検索するアセットバージョン
   * @returns MstCharacterSkin[]
   */
  static searchMstCharacterSkinByAssetVersion(
    assetVersion: string
  ): MstCharacterSkin[] {
    return MasterDataClient.getMstCharacterSkinAll().filter((item) =>
      item.asset_version?.includes(assetVersion)
    );
  }

  /**
   * MstCharacterSkinをキャラクターマスタIDで検索
   * @param mstCharacterID 検索するキャラクターマスタID
   * @returns MstCharacterSkin[]
   */
  static searchMstCharacterSkinByMstCharacterID(
    mstCharacterID: number
  ): MstCharacterSkin[] {
    return MasterDataClient.getMstCharacterSkinAll().filter(
      (item) => item.mst_character_id === mstCharacterID
    );
  }

  /**
   * MstCurrencyをアセットバージョンで検索
   * @param assetVersion 検索するアセットバージョン
   * @returns MstCurrency[]
   */
  static searchMstCurrencyByAssetVersion(assetVersion: string): MstCurrency[] {
    return MasterDataClient.getMstCurrencyAll().filter((item) =>
      item.asset_version?.includes(assetVersion)
    );
  }

  /**
   * MstCurrencyを１度に獲得する単位個数で検索
   * @param baseAmount 検索する１度に獲得する単位個数
   * @returns MstCurrency[]
   */
  static searchMstCurrencyByBaseAmount(baseAmount: number): MstCurrency[] {
    return MasterDataClient.getMstCurrencyAll().filter(
      (item) => item.base_amount === baseAmount
    );
  }

  /**
   * MstCurrencyを通貨種別で検索
   * @param currencyType 検索する通貨種別
   * @returns MstCurrency[]
   */
  static searchMstCurrencyByCurrencyType(currencyType: string): MstCurrency[] {
    return MasterDataClient.getMstCurrencyAll().filter((item) =>
      item.currency_type?.includes(currencyType)
    );
  }

  /**
   * MstCurrencyを期限切れ日時(固定期限でない場合は初期値)で検索
   * @param expireDate 検索する期限切れ日時(固定期限でない場合は初期値)
   * @returns MstCurrency[]
   */
  static searchMstCurrencyByExpireDate(expireDate: string): MstCurrency[] {
    return MasterDataClient.getMstCurrencyAll().filter(
      (item) => item.expire_date === expireDate
    );
  }

  /**
   * MstCurrencyを期限切れ日数(固定期限の場合は0)で検索
   * @param expireDay 検索する期限切れ日数(固定期限の場合は0)
   * @returns MstCurrency[]
   */
  static searchMstCurrencyByExpireDay(expireDay: number): MstCurrency[] {
    return MasterDataClient.getMstCurrencyAll().filter(
      (item) => item.expire_day === expireDay
    );
  }

  /**
   * MstCurrencyを期限切れ種別で検索
   * @param expireType 検索する期限切れ種別
   * @returns MstCurrency[]
   */
  static searchMstCurrencyByExpireType(expireType: number): MstCurrency[] {
    return MasterDataClient.getMstCurrencyAll().filter(
      (item) => item.expire_type === expireType
    );
  }

  /**
   * MstCurrencyをアイテム種別で検索
   * @param itemType 検索するアイテム種別
   * @returns MstCurrency[]
   */
  static searchMstCurrencyByItemType(itemType: string): MstCurrency[] {
    return MasterDataClient.getMstCurrencyAll().filter((item) =>
      item.item_type?.includes(itemType)
    );
  }

  /**
   * MstCurrencyを所持上限数(0: 無制限)で検索
   * @param limit 検索する所持上限数(0: 無制限)
   * @returns MstCurrency[]
   */
  static searchMstCurrencyByLimit(limit: number): MstCurrency[] {
    return MasterDataClient.getMstCurrencyAll().filter(
      (item) => item.limit === limit
    );
  }

  /**
   * MstCurrencyを通貨名で検索
   * @param name 検索する通貨名
   * @returns MstCurrency[]
   */
  static searchMstCurrencyByName(name: string): MstCurrency[] {
    return MasterDataClient.getMstCurrencyAll().filter((item) =>
      item.name?.includes(name)
    );
  }

  /**
   * MstErrorCodeをアセットバージョンで検索
   * @param assetVersion 検索するアセットバージョン
   * @returns MstErrorCode[]
   */
  static searchMstErrorCodeByAssetVersion(
    assetVersion: string
  ): MstErrorCode[] {
    return MasterDataClient.getMstErrorCodeAll().filter((item) =>
      item.asset_version?.includes(assetVersion)
    );
  }

  /**
   * MstErrorCodeをエラーコードで検索
   * @param code 検索するエラーコード
   * @returns MstErrorCode[]
   */
  static searchMstErrorCodeByCode(code: number): MstErrorCode[] {
    return MasterDataClient.getMstErrorCodeAll().filter(
      (item) => item.code === code
    );
  }

  /**
   * MstErrorCodeをリトライ可能なエラーかのフラグで検索
   * @param isRetry 検索するリトライ可能なエラーかのフラグ
   * @returns MstErrorCode[]
   */
  static searchMstErrorCodeByIsRetry(isRetry: boolean): MstErrorCode[] {
    return MasterDataClient.getMstErrorCodeAll().filter(
      (item) => item.is_retry === isRetry
    );
  }

  /**
   * MstErrorCodeをユーザーに表示するメッセージで検索
   * @param message 検索するユーザーに表示するメッセージ
   * @returns MstErrorCode[]
   */
  static searchMstErrorCodeByMessage(message: string): MstErrorCode[] {
    return MasterDataClient.getMstErrorCodeAll().filter((item) =>
      item.message?.includes(message)
    );
  }

  /**
   * MstHomeBackgroundをアセットバージョンで検索
   * @param assetVersion 検索するアセットバージョン
   * @returns MstHomeBackground[]
   */
  static searchMstHomeBackgroundByAssetVersion(
    assetVersion: string
  ): MstHomeBackground[] {
    return MasterDataClient.getMstHomeBackgroundAll().filter((item) =>
      item.asset_version?.includes(assetVersion)
    );
  }

  /**
   * MstHomeBackgroundをで検索
   * @param name 検索する
   * @returns MstHomeBackground[]
   */
  static searchMstHomeBackgroundByName(name: string): MstHomeBackground[] {
    return MasterDataClient.getMstHomeBackgroundAll().filter((item) =>
      item.name?.includes(name)
    );
  }

  /**
   * MstIconをアセットバージョンで検索
   * @param assetVersion 検索するアセットバージョン
   * @returns MstIcon[]
   */
  static searchMstIconByAssetVersion(assetVersion: string): MstIcon[] {
    return MasterDataClient.getMstIconAll().filter((item) =>
      item.asset_version?.includes(assetVersion)
    );
  }

  /**
   * MstIconをで検索
   * @param name 検索する
   * @returns MstIcon[]
   */
  static searchMstIconByName(name: string): MstIcon[] {
    return MasterDataClient.getMstIconAll().filter((item) =>
      item.name?.includes(name)
    );
  }

  /**
   * MstIconFrameをアセットバージョンで検索
   * @param assetVersion 検索するアセットバージョン
   * @returns MstIconFrame[]
   */
  static searchMstIconFrameByAssetVersion(
    assetVersion: string
  ): MstIconFrame[] {
    return MasterDataClient.getMstIconFrameAll().filter((item) =>
      item.asset_version?.includes(assetVersion)
    );
  }

  /**
   * MstIconFrameをで検索
   * @param name 検索する
   * @returns MstIconFrame[]
   */
  static searchMstIconFrameByName(name: string): MstIconFrame[] {
    return MasterDataClient.getMstIconFrameAll().filter((item) =>
      item.name?.includes(name)
    );
  }

  /**
   * MstMissionをアセットバージョンで検索
   * @param assetVersion 検索するアセットバージョン
   * @returns MstMission[]
   */
  static searchMstMissionByAssetVersion(assetVersion: string): MstMission[] {
    return MasterDataClient.getMstMissionAll().filter((item) =>
      item.asset_version?.includes(assetVersion)
    );
  }

  /**
   * MstMissionを達成に必要な目標値で検索
   * @param goal 検索する達成に必要な目標値
   * @returns MstMission[]
   */
  static searchMstMissionByGoal(goal: number): MstMission[] {
    return MasterDataClient.getMstMissionAll().filter(
      (item) => item.goal === goal
    );
  }

  /**
   * MstMissionをユーザーへ表示するかのフラグ(達成すると付与はされる。マル秘ミッションとかシークレットミッション的なやつ)で検索
   * @param isDisplayed 検索するユーザーへ表示するかのフラグ(達成すると付与はされる。マル秘ミッションとかシークレットミッション的なやつ)
   * @returns MstMission[]
   */
  static searchMstMissionByIsDisplayed(isDisplayed: boolean): MstMission[] {
    return MasterDataClient.getMstMissionAll().filter(
      (item) => item.is_displayed === isDisplayed
    );
  }

  /**
   * MstMissionを報酬アイテム付与個数で検索
   * @param itemAmountList 検索する報酬アイテム付与個数
   * @returns MstMission[]
   */
  static searchMstMissionByItemAmountList(
    itemAmountList: number
  ): MstMission[] {
    return MasterDataClient.getMstMissionAll().filter((item) =>
      item.item_amount_list?.includes(itemAmountList)
    );
  }

  /**
   * MstMissionを報酬のアイテム種別リストで検索
   * @param itemTypeList 検索する報酬のアイテム種別リスト
   * @returns MstMission[]
   */
  static searchMstMissionByItemTypeList(itemTypeList: string): MstMission[] {
    return MasterDataClient.getMstMissionAll().filter((item) =>
      item.item_type_list?.includes(itemTypeList)
    );
  }

  /**
   * MstMissionをミッション種別で検索
   * @param missionType 検索するミッション種別
   * @returns MstMission[]
   */
  static searchMstMissionByMissionType(missionType: number): MstMission[] {
    return MasterDataClient.getMstMissionAll().filter(
      (item) => item.mission_type === missionType
    );
  }

  /**
   * MstMissionをミッション名で検索
   * @param name 検索するミッション名
   * @returns MstMission[]
   */
  static searchMstMissionByName(name: string): MstMission[] {
    return MasterDataClient.getMstMissionAll().filter((item) =>
      item.name?.includes(name)
    );
  }

  /**
   * MstMissionをタスク種別に応じて役割が変わる値で検索
   * @param option1 検索するタスク種別に応じて役割が変わる値
   * @returns MstMission[]
   */
  static searchMstMissionByOption1(option1: string): MstMission[] {
    return MasterDataClient.getMstMissionAll().filter((item) =>
      item.option1?.includes(option1)
    );
  }

  /**
   * MstMissionをタスクに応じて役割が変わるオプション値2で検索
   * @param option2 検索するタスクに応じて役割が変わるオプション値2
   * @returns MstMission[]
   */
  static searchMstMissionByOption2(option2: string): MstMission[] {
    return MasterDataClient.getMstMissionAll().filter((item) =>
      item.option2?.includes(option2)
    );
  }

  /**
   * MstMissionをで検索
   * @param optionList 検索する
   * @returns MstMission[]
   */
  static searchMstMissionByOptionList(optionList: string): MstMission[] {
    return MasterDataClient.getMstMissionAll().filter((item) =>
      item.option_list?.includes(optionList)
    );
  }

  /**
   * MstMissionをミッションのタスク種別で検索
   * @param taskType 検索するミッションのタスク種別
   * @returns MstMission[]
   */
  static searchMstMissionByTaskType(taskType: number): MstMission[] {
    return MasterDataClient.getMstMissionAll().filter(
      (item) => item.task_type === taskType
    );
  }

  /**
   * MstPaidShopをで検索
   * @param androidBundleName 検索する
   * @returns MstPaidShop[]
   */
  static searchMstPaidShopByAndroidBundleName(
    androidBundleName: string
  ): MstPaidShop[] {
    return MasterDataClient.getMstPaidShopAll().filter((item) =>
      item.android_bundle_name?.includes(androidBundleName)
    );
  }

  /**
   * MstPaidShopをアセットバージョンで検索
   * @param assetVersion 検索するアセットバージョン
   * @returns MstPaidShop[]
   */
  static searchMstPaidShopByAssetVersion(assetVersion: string): MstPaidShop[] {
    return MasterDataClient.getMstPaidShopAll().filter((item) =>
      item.asset_version?.includes(assetVersion)
    );
  }

  /**
   * MstPaidShopをで検索
   * @param dailyLimit 検索する
   * @returns MstPaidShop[]
   */
  static searchMstPaidShopByDailyLimit(dailyLimit: number): MstPaidShop[] {
    return MasterDataClient.getMstPaidShopAll().filter(
      (item) => item.daily_limit === dailyLimit
    );
  }

  /**
   * MstPaidShopをで検索
   * @param fastSpringBundleName 検索する
   * @returns MstPaidShop[]
   */
  static searchMstPaidShopByFastSpringBundleName(
    fastSpringBundleName: string
  ): MstPaidShop[] {
    return MasterDataClient.getMstPaidShopAll().filter((item) =>
      item.fast_spring_bundle_name?.includes(fastSpringBundleName)
    );
  }

  /**
   * MstPaidShopをで検索
   * @param iosBundleName 検索する
   * @returns MstPaidShop[]
   */
  static searchMstPaidShopByIOSBundleName(
    iosBundleName: string
  ): MstPaidShop[] {
    return MasterDataClient.getMstPaidShopAll().filter((item) =>
      item.ios_bundle_name?.includes(iosBundleName)
    );
  }

  /**
   * MstPaidShopをアイテム付与個数で検索
   * @param itemAmountList 検索するアイテム付与個数
   * @returns MstPaidShop[]
   */
  static searchMstPaidShopByItemAmountList(
    itemAmountList: number
  ): MstPaidShop[] {
    return MasterDataClient.getMstPaidShopAll().filter((item) =>
      item.item_amount_list?.includes(itemAmountList)
    );
  }

  /**
   * MstPaidShopを付与するアイテムIDリストで検索
   * @param itemTypeList 検索する付与するアイテムIDリスト
   * @returns MstPaidShop[]
   */
  static searchMstPaidShopByItemTypeList(itemTypeList: string): MstPaidShop[] {
    return MasterDataClient.getMstPaidShopAll().filter((item) =>
      item.item_type_list?.includes(itemTypeList)
    );
  }

  /**
   * MstPaidShopをで検索
   * @param jpyPrice 検索する
   * @returns MstPaidShop[]
   */
  static searchMstPaidShopByJPYPrice(jpyPrice: number): MstPaidShop[] {
    return MasterDataClient.getMstPaidShopAll().filter(
      (item) => item.jpy_price === jpyPrice
    );
  }

  /**
   * MstPaidShopをで検索
   * @param limitScopeType 検索する
   * @returns MstPaidShop[]
   */
  static searchMstPaidShopByLimitScopeType(
    limitScopeType: number
  ): MstPaidShop[] {
    return MasterDataClient.getMstPaidShopAll().filter(
      (item) => item.limit_scope_type === limitScopeType
    );
  }

  /**
   * MstPaidShopをで検索
   * @param monthlyLimit 検索する
   * @returns MstPaidShop[]
   */
  static searchMstPaidShopByMonthlyLimit(monthlyLimit: number): MstPaidShop[] {
    return MasterDataClient.getMstPaidShopAll().filter(
      (item) => item.monthly_limit === monthlyLimit
    );
  }

  /**
   * MstPaidShopを商品名で検索
   * @param name 検索する商品名
   * @returns MstPaidShop[]
   */
  static searchMstPaidShopByName(name: string): MstPaidShop[] {
    return MasterDataClient.getMstPaidShopAll().filter((item) =>
      item.name?.includes(name)
    );
  }

  /**
   * MstPaidShopをで検索
   * @param optionList 検索する
   * @returns MstPaidShop[]
   */
  static searchMstPaidShopByOptionList(optionList: string): MstPaidShop[] {
    return MasterDataClient.getMstPaidShopAll().filter((item) =>
      item.option_list?.includes(optionList)
    );
  }

  /**
   * MstPaidShopをで検索
   * @param steamBundleName 検索する
   * @returns MstPaidShop[]
   */
  static searchMstPaidShopBySteamBundleName(
    steamBundleName: string
  ): MstPaidShop[] {
    return MasterDataClient.getMstPaidShopAll().filter((item) =>
      item.steam_bundle_name?.includes(steamBundleName)
    );
  }

  /**
   * MstPaidShopをで検索
   * @param stripePriceID 検索する
   * @returns MstPaidShop[]
   */
  static searchMstPaidShopByStripePriceID(
    stripePriceID: string
  ): MstPaidShop[] {
    return MasterDataClient.getMstPaidShopAll().filter((item) =>
      item.stripe_price_id?.includes(stripePriceID)
    );
  }

  /**
   * MstPaidShopをで検索
   * @param totalLimit 検索する
   * @returns MstPaidShop[]
   */
  static searchMstPaidShopByTotalLimit(totalLimit: number): MstPaidShop[] {
    return MasterDataClient.getMstPaidShopAll().filter(
      (item) => item.total_limit === totalLimit
    );
  }

  /**
   * MstPaidShopBundleSetをで検索
   * @param androidBundleName 検索する
   * @returns MstPaidShopBundleSet[]
   */
  static searchMstPaidShopBundleSetByAndroidBundleName(
    androidBundleName: string
  ): MstPaidShopBundleSet[] {
    return MasterDataClient.getMstPaidShopBundleSetAll().filter((item) =>
      item.android_bundle_name?.includes(androidBundleName)
    );
  }

  /**
   * MstPaidShopBundleSetをアセットバージョンで検索
   * @param assetVersion 検索するアセットバージョン
   * @returns MstPaidShopBundleSet[]
   */
  static searchMstPaidShopBundleSetByAssetVersion(
    assetVersion: string
  ): MstPaidShopBundleSet[] {
    return MasterDataClient.getMstPaidShopBundleSetAll().filter((item) =>
      item.asset_version?.includes(assetVersion)
    );
  }

  /**
   * MstPaidShopBundleSetをで検索
   * @param fastSpringBundleName 検索する
   * @returns MstPaidShopBundleSet[]
   */
  static searchMstPaidShopBundleSetByFastSpringBundleName(
    fastSpringBundleName: string
  ): MstPaidShopBundleSet[] {
    return MasterDataClient.getMstPaidShopBundleSetAll().filter((item) =>
      item.fast_spring_bundle_name?.includes(fastSpringBundleName)
    );
  }

  /**
   * MstPaidShopBundleSetをで検索
   * @param iosBundleName 検索する
   * @returns MstPaidShopBundleSet[]
   */
  static searchMstPaidShopBundleSetByIOSBundleName(
    iosBundleName: string
  ): MstPaidShopBundleSet[] {
    return MasterDataClient.getMstPaidShopBundleSetAll().filter((item) =>
      item.ios_bundle_name?.includes(iosBundleName)
    );
  }

  /**
   * MstPaidShopBundleSetを日本価格で検索
   * @param jpyPrice 検索する日本価格
   * @returns MstPaidShopBundleSet[]
   */
  static searchMstPaidShopBundleSetByJPYPrice(
    jpyPrice: number
  ): MstPaidShopBundleSet[] {
    return MasterDataClient.getMstPaidShopBundleSetAll().filter(
      (item) => item.jpy_price === jpyPrice
    );
  }

  /**
   * MstPaidShopBundleSetをセットに含まれる有償ショップIDリストで検索
   * @param mstPaidShopIDList 検索するセットに含まれる有償ショップIDリスト
   * @returns MstPaidShopBundleSet[]
   */
  static searchMstPaidShopBundleSetByMstPaidShopIDList(
    mstPaidShopIDList: number
  ): MstPaidShopBundleSet[] {
    return MasterDataClient.getMstPaidShopBundleSetAll().filter((item) =>
      item.mst_paid_shop_id_list?.includes(mstPaidShopIDList)
    );
  }

  /**
   * MstPaidShopBundleSetを商品名で検索
   * @param name 検索する商品名
   * @returns MstPaidShopBundleSet[]
   */
  static searchMstPaidShopBundleSetByName(
    name: string
  ): MstPaidShopBundleSet[] {
    return MasterDataClient.getMstPaidShopBundleSetAll().filter((item) =>
      item.name?.includes(name)
    );
  }

  /**
   * MstPaidShopBundleSetを価格割合リストで検索
   * @param priceRatioList 検索する価格割合
   * @returns MstPaidShopBundleSet[]
   */
  static searchMstPaidShopBundleSetByPriceRatioList(
    priceRatioList: number
  ): MstPaidShopBundleSet[] {
    return MasterDataClient.getMstPaidShopBundleSetAll().filter((item) =>
      item.price_ratio_list?.includes(priceRatioList)
    );
  }

  /**
   * MstPaidShopBundleSetをで検索
   * @param steamBundleName 検索する
   * @returns MstPaidShopBundleSet[]
   */
  static searchMstPaidShopBundleSetBySteamBundleName(
    steamBundleName: string
  ): MstPaidShopBundleSet[] {
    return MasterDataClient.getMstPaidShopBundleSetAll().filter((item) =>
      item.steam_bundle_name?.includes(steamBundleName)
    );
  }

  /**
   * MstSeasonをアセットバージョンで検索
   * @param assetVersion 検索するアセットバージョン
   * @returns MstSeason[]
   */
  static searchMstSeasonByAssetVersion(assetVersion: string): MstSeason[] {
    return MasterDataClient.getMstSeasonAll().filter((item) =>
      item.asset_version?.includes(assetVersion)
    );
  }

  /**
   * MstShogiBoardをアセットバージョンで検索
   * @param assetVersion 検索するアセットバージョン
   * @returns MstShogiBoard[]
   */
  static searchMstShogiBoardByAssetVersion(
    assetVersion: string
  ): MstShogiBoard[] {
    return MasterDataClient.getMstShogiBoardAll().filter((item) =>
      item.asset_version?.includes(assetVersion)
    );
  }

  /**
   * MstShogiBoardをで検索
   * @param name 検索する
   * @returns MstShogiBoard[]
   */
  static searchMstShogiBoardByName(name: string): MstShogiBoard[] {
    return MasterDataClient.getMstShogiBoardAll().filter((item) =>
      item.name?.includes(name)
    );
  }

  /**
   * MstShogiIngameBGMをアセットバージョンで検索
   * @param assetVersion 検索するアセットバージョン
   * @returns MstShogiIngameBGM[]
   */
  static searchMstShogiIngameBGMByAssetVersion(
    assetVersion: string
  ): MstShogiIngameBGM[] {
    return MasterDataClient.getMstShogiIngameBGMAll().filter((item) =>
      item.asset_version?.includes(assetVersion)
    );
  }

  /**
   * MstShogiIngameBGMをで検索
   * @param name 検索する
   * @returns MstShogiIngameBGM[]
   */
  static searchMstShogiIngameBGMByName(name: string): MstShogiIngameBGM[] {
    return MasterDataClient.getMstShogiIngameBGMAll().filter((item) =>
      item.name?.includes(name)
    );
  }

  /**
   * MstShogiPieceをアセットバージョンで検索
   * @param assetVersion 検索するアセットバージョン
   * @returns MstShogiPiece[]
   */
  static searchMstShogiPieceByAssetVersion(
    assetVersion: string
  ): MstShogiPiece[] {
    return MasterDataClient.getMstShogiPieceAll().filter((item) =>
      item.asset_version?.includes(assetVersion)
    );
  }

  /**
   * MstShogiPieceをで検索
   * @param name 検索する
   * @returns MstShogiPiece[]
   */
  static searchMstShogiPieceByName(name: string): MstShogiPiece[] {
    return MasterDataClient.getMstShogiPieceAll().filter((item) =>
      item.name?.includes(name)
    );
  }

  /**
   * MstShogiPieceをで検索
   * @param rarity 検索する
   * @returns MstShogiPiece[]
   */
  static searchMstShogiPieceByRarity(rarity: number): MstShogiPiece[] {
    return MasterDataClient.getMstShogiPieceAll().filter(
      (item) => item.rarity === rarity
    );
  }

  /**
   * MstShogiPieceEffectをアセットバージョンで検索
   * @param assetVersion 検索するアセットバージョン
   * @returns MstShogiPieceEffect[]
   */
  static searchMstShogiPieceEffectByAssetVersion(
    assetVersion: string
  ): MstShogiPieceEffect[] {
    return MasterDataClient.getMstShogiPieceEffectAll().filter((item) =>
      item.asset_version?.includes(assetVersion)
    );
  }

  /**
   * MstShogiPieceEffectをで検索
   * @param name 検索する
   * @returns MstShogiPieceEffect[]
   */
  static searchMstShogiPieceEffectByName(name: string): MstShogiPieceEffect[] {
    return MasterDataClient.getMstShogiPieceEffectAll().filter((item) =>
      item.name?.includes(name)
    );
  }

  /**
   * MstShogiPieceSoundをアセットバージョンで検索
   * @param assetVersion 検索するアセットバージョン
   * @returns MstShogiPieceSound[]
   */
  static searchMstShogiPieceSoundByAssetVersion(
    assetVersion: string
  ): MstShogiPieceSound[] {
    return MasterDataClient.getMstShogiPieceSoundAll().filter((item) =>
      item.asset_version?.includes(assetVersion)
    );
  }

  /**
   * MstShogiPieceSoundをで検索
   * @param name 検索する
   * @returns MstShogiPieceSound[]
   */
  static searchMstShogiPieceSoundByName(name: string): MstShogiPieceSound[] {
    return MasterDataClient.getMstShogiPieceSoundAll().filter((item) =>
      item.name?.includes(name)
    );
  }

  /**
   * MstSubscriptionPlanをアセットバージョンで検索
   * @param assetVersion 検索するアセットバージョン
   * @returns MstSubscriptionPlan[]
   */
  static searchMstSubscriptionPlanByAssetVersion(
    assetVersion: string
  ): MstSubscriptionPlan[] {
    return MasterDataClient.getMstSubscriptionPlanAll().filter((item) =>
      item.asset_version?.includes(assetVersion)
    );
  }

  /**
   * MstSubscriptionPlanをサブスクリプションの期限種別で検索
   * @param intervalType 検索するサブスクリプションの期限種別
   * @returns MstSubscriptionPlan[]
   */
  static searchMstSubscriptionPlanByIntervalType(
    intervalType: string
  ): MstSubscriptionPlan[] {
    return MasterDataClient.getMstSubscriptionPlanAll().filter((item) =>
      item.interval_type?.includes(intervalType)
    );
  }

  /**
   * MstSubscriptionPlanをで検索
   * @param jpyPrice 検索する
   * @returns MstSubscriptionPlan[]
   */
  static searchMstSubscriptionPlanByJPYPrice(
    jpyPrice: number
  ): MstSubscriptionPlan[] {
    return MasterDataClient.getMstSubscriptionPlanAll().filter(
      (item) => item.jpy_price === jpyPrice
    );
  }

  /**
   * MstSubscriptionPlanをで検索
   * @param stripePriceID 検索する
   * @returns MstSubscriptionPlan[]
   */
  static searchMstSubscriptionPlanByStripePriceID(
    stripePriceID: string
  ): MstSubscriptionPlan[] {
    return MasterDataClient.getMstSubscriptionPlanAll().filter((item) =>
      item.stripe_price_id?.includes(stripePriceID)
    );
  }

  /**
   * MstSubscriptionPlanをで検索
   * @param subscriptionType 検索する
   * @returns MstSubscriptionPlan[]
   */
  static searchMstSubscriptionPlanBySubscriptionType(
    subscriptionType: string
  ): MstSubscriptionPlan[] {
    return MasterDataClient.getMstSubscriptionPlanAll().filter((item) =>
      item.subscription_type?.includes(subscriptionType)
    );
  }
}

// マスターセレクター統合クラス
export class MasterDataSelectors {
  // マスター情報のメタデータ
  private static readonly MASTER_INFO = [
    {
      name: "MstAchievement",
      typeName: "MstAchievement",
      idType: "MstAchievementID",
      jsonKey: "mst_achievement",
      selectorFieldName: "mst_achievement",
      selectorComponent: MstAchievementSelector,
    },

    {
      name: "MstAssetVersion",
      typeName: "MstAssetVersion",
      idType: "MstAssetVersionID",
      jsonKey: "mst_asset_version",
      selectorFieldName: "mst_asset_version",
      selectorComponent: MstAssetVersionSelector,
    },

    {
      name: "MstCharacter",
      typeName: "MstCharacter",
      idType: "MstCharacterID",
      jsonKey: "mst_character",
      selectorFieldName: "mst_character",
      selectorComponent: MstCharacterSelector,
    },

    {
      name: "MstCharacterBond",
      typeName: "MstCharacterBond",
      idType: "MstCharacterBondID",
      jsonKey: "mst_character_bond",
      selectorFieldName: "mst_character_bond",
      selectorComponent: MstCharacterBondSelector,
    },

    {
      name: "MstCharacterProfile",
      typeName: "MstCharacterProfile",
      idType: "MstCharacterProfileID",
      jsonKey: "mst_character_profile",
      selectorFieldName: "mst_character_profile",
      selectorComponent: MstCharacterProfileSelector,
    },

    {
      name: "MstCharacterSkin",
      typeName: "MstCharacterSkin",
      idType: "MstCharacterSkinID",
      jsonKey: "mst_character_skin",
      selectorFieldName: "mst_character_skin",
      selectorComponent: MstCharacterSkinSelector,
    },

    {
      name: "MstCurrency",
      typeName: "MstCurrency",
      idType: "MstCurrencyID",
      jsonKey: "mst_currency",
      selectorFieldName: "mst_currency",
      selectorComponent: MstCurrencySelector,
    },

    {
      name: "MstErrorCode",
      typeName: "MstErrorCode",
      idType: "MstErrorCodeID",
      jsonKey: "mst_error_code",
      selectorFieldName: "mst_error_code",
      selectorComponent: MstErrorCodeSelector,
    },

    {
      name: "MstHomeBackground",
      typeName: "MstHomeBackground",
      idType: "MstHomeBackgroundID",
      jsonKey: "mst_home_background",
      selectorFieldName: "mst_home_background",
      selectorComponent: MstHomeBackgroundSelector,
    },

    {
      name: "MstIcon",
      typeName: "MstIcon",
      idType: "MstIconID",
      jsonKey: "mst_icon",
      selectorFieldName: "mst_icon",
      selectorComponent: MstIconSelector,
    },

    {
      name: "MstIconFrame",
      typeName: "MstIconFrame",
      idType: "MstIconFrameID",
      jsonKey: "mst_icon_frame",
      selectorFieldName: "mst_icon_frame",
      selectorComponent: MstIconFrameSelector,
    },

    {
      name: "MstMission",
      typeName: "MstMission",
      idType: "MstMissionID",
      jsonKey: "mst_mission",
      selectorFieldName: "mst_mission",
      selectorComponent: MstMissionSelector,
    },

    {
      name: "MstPaidShop",
      typeName: "MstPaidShop",
      idType: "MstPaidShopID",
      jsonKey: "mst_paid_shop",
      selectorFieldName: "mst_paid_shop",
      selectorComponent: MstPaidShopSelector,
    },

    {
      name: "MstPaidShopBundleSet",
      typeName: "MstPaidShopBundleSet",
      idType: "MstPaidShopBundleSetID",
      jsonKey: "mst_paid_shop_bundle_set",
      selectorFieldName: "mst_paid_shop_bundle_set",
      selectorComponent: MstPaidShopBundleSetSelector,
    },

    {
      name: "MstSeason",
      typeName: "MstSeason",
      idType: "MstSeasonID",
      jsonKey: "mst_season",
      selectorFieldName: "mst_season",
      selectorComponent: MstSeasonSelector,
    },

    {
      name: "MstShogiBoard",
      typeName: "MstShogiBoard",
      idType: "MstShogiBoardID",
      jsonKey: "mst_shogi_board",
      selectorFieldName: "mst_shogi_board",
      selectorComponent: MstShogiBoardSelector,
    },

    {
      name: "MstShogiIngameBGM",
      typeName: "MstShogiIngameBGM",
      idType: "MstShogiIngameBGMID",
      jsonKey: "mst_shogi_ingame_bgm",
      selectorFieldName: "mst_shogi_ingame_bgm",
      selectorComponent: MstShogiIngameBGMSelector,
    },

    {
      name: "MstShogiPiece",
      typeName: "MstShogiPiece",
      idType: "MstShogiPieceID",
      jsonKey: "mst_shogi_piece",
      selectorFieldName: "mst_shogi_piece",
      selectorComponent: MstShogiPieceSelector,
    },

    {
      name: "MstShogiPieceEffect",
      typeName: "MstShogiPieceEffect",
      idType: "MstShogiPieceEffectID",
      jsonKey: "mst_shogi_piece_effect",
      selectorFieldName: "mst_shogi_piece_effect",
      selectorComponent: MstShogiPieceEffectSelector,
    },

    {
      name: "MstShogiPieceSound",
      typeName: "MstShogiPieceSound",
      idType: "MstShogiPieceSoundID",
      jsonKey: "mst_shogi_piece_sound",
      selectorFieldName: "mst_shogi_piece_sound",
      selectorComponent: MstShogiPieceSoundSelector,
    },

    {
      name: "MstSubscriptionPlan",
      typeName: "MstSubscriptionPlan",
      idType: "MstSubscriptionPlanID",
      jsonKey: "mst_subscription_plan",
      selectorFieldName: "mst_subscription_plan",
      selectorComponent: MstSubscriptionPlanSelector,
    },
  ];

  // セレクターコンポーネントのマッピング（動的に構築）
  private static _selectorMap: Map<string, React.ComponentType<any>> | null =
    null;

  /**
   * セレクターマッピングを初期化
   */
  private static initializeSelectorMap(): void {
    if (this._selectorMap !== null) return;

    this._selectorMap = new Map();
    this.MASTER_INFO.forEach((master) => {
      this._selectorMap!.set(master.idType, master.selectorComponent);
    });
  }

  /**
   * 型情報からマスターセレクターコンポーネントを取得
   * @param fieldType フィールドの型（例: "master.MstItemID", "MasterMstItemID"）
   * @returns セレクターコンポーネントまたはnull
   */
  static getSelectorComponentByType(
    fieldType: string
  ): React.ComponentType<any> | null {
    this.initializeSelectorMap();

    // 配列型の場合は要素型を取得
    const baseType = fieldType.replace("[]", "");

    let masterTypeName: string;

    // master.MstXXXID形式の場合
    if (baseType.startsWith("master.Mst") && baseType.endsWith("ID")) {
      masterTypeName = baseType.replace("master.", "");
    }
    // MasterMstXXXID形式の場合（frontendType）
    else if (baseType.startsWith("MasterMst") && baseType.endsWith("ID")) {
      masterTypeName = baseType.replace("Master", "");
    } else {
      return null;
    }

    return this._selectorMap!.get(masterTypeName) || null;
  }

  // フィールド名ベースのセレクターマッピング（動的に構築）
  private static _fieldNameMap: Map<string, React.ComponentType<any>> | null =
    null;

  /**
   * フィールド名マッピングを初期化
   */
  private static initializeFieldNameMap(): void {
    if (this._fieldNameMap !== null) return;

    this._fieldNameMap = new Map();
    this.MASTER_INFO.forEach((master) => {
      this._fieldNameMap!.set(
        master.selectorFieldName,
        master.selectorComponent
      );
    });
  }

  /**
   * 型情報からマスターIDフィールドかどうかを判定
   * @param fieldType フィールドの型
   * @returns マスターIDフィールドかどうか
   */
  static isMasterIdFieldByType(fieldType: string): boolean {
    return this.getSelectorComponentByType(fieldType) !== null;
  }

  /**
   * 利用可能なマスターセレクターの一覧を取得
   * @returns マスターセレクター情報の配列
   */
  static getAvailableSelectors(): Array<{
    fieldSuffix: string;
    masterType: string;
    selectorComponent: React.ComponentType<any>;
  }> {
    return this.MASTER_INFO.map((master) => ({
      fieldSuffix: `${master.selectorFieldName}_id`,
      masterType: master.typeName,
      selectorComponent: master.selectorComponent,
    }));
  }

  /**
   * マスター情報のメタデータを取得
   * @returns マスター情報の配列
   */
  static getMasterInfo() {
    return [...this.MASTER_INFO];
  }
}

// エクスポート
export { MasterDataClient as MasterData };
export default MasterDataClient;
